import { Component, Input, OnChanges, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Account } from '../models/Account';
import { CreateKaizen, KaizenAccountList } from '../models/Kaizen';
import { KaizenMonthlySaving } from '../models/KaizenMonthlySaving';
import { KaizenAccount } from '../models/kaizen-account';
import { PRKaizenMonthlySavingsList } from '../models/kaizen-monthly-savings-list';
import { SavingsMeasure } from '../models/SavingsMeasure';
import { YearlyProductFacts } from '../models/YearlyProductFacts';
import { AccountService } from '../Services/Account.Services';
import { KaizenService } from '../Services/Kaizen.Service';
import { YearlyProductFactsService } from '../Services/YearlyProductFacts.Service';
import { DialogDeleteAccountWithActualsConfirmComponent } from '../dialogdeleteaccountwithactualsconfirm/dialogdeleteaccountwithactualsconfirm.component';
import { MatDialog} from '@angular/material/dialog';
import { CostDirection } from '../models/CostDirection';
import { CostType } from '../models/CostType';
import { DetailedAccount } from '../models/DetailedAccount';
import { CostDirectionService } from '../Services/CostDirection.Services';
import { CostTypeService } from '../Services/CostType.Services';
import { DetailedAccountService } from '../Services/DetailedAccount.Services';
import { SavingsMeasureService } from '../Services/SavingsMeasure.Services';
import { DialogaccountdeleteService } from '../Services/dialogaccountdelete.service';
import { CurrencyService } from '../Services/Currency.Service';
import { Currency } from '../models/Currency';
import {YearsWithCapacity} from '../models/YearsWithCapacity';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-accountstab',
    templateUrl: './accountstab.component.html',
    styleUrls: ['./accountstab.component.css'],
    standalone: false
})

export class AccountstabComponent implements OnChanges {
  CreateKaizenAcc: CreateKaizen = new CreateKaizen();
  @Input() CreateKaizen: CreateKaizen = new CreateKaizen();
  @Input() reloadKaizenId: number = 0;
  @Output() emitKaizenAcounts: EventEmitter<CreateKaizen> = new EventEmitter<CreateKaizen>();
  editKaizenId: number = 0;
  accountsLoaded !: boolean;
  public reApprovalReq: boolean = false;
  accounts!: Account[];
  kaizenMonthlySavingsList!: PRKaizenMonthlySavingsList;
  public kaizenAccountArray!: any;
  showTotalCostTable: boolean[] = [];
  days: { Id: string, Name: string }[] = [];
  showCostPerUnitTable: boolean[] = [];
  showProcessReductionTable: boolean[] = [];
  showTotalWorkingTimeReductionTable: boolean[] = [];
  kaizenAccounts: KaizenAccount = new KaizenAccount();
  public kTotalCostAry!: any;
  filteredCostDirectionsArray: any[] = [];
  filteredCostTypeArray: any[] = [];
  filteredAccountsArray: any[] = [];
  filteredSavingNMeasuresArray: any[] = [];
  filteredSavingNMeasuresArraytmp: any[] = [];
  filteredDetailedAccountsArray: any[] = [];
  filteredCostCentersArray: any[] = [];
  btnAddAccountShow: boolean[] = [];
  labourcls: string[] = [];
  accountArray!: UntypedFormArray;
  public accountCounter: number = 0;
  yearlyProductFactsAcAry: any[] = [];
  cPuProductFactsAcAry: any[] = [];
  cPuNetTotalProductFactsAcAry: any[] = [];
  KaizenMonthlySavingAccountsAry: any[] = [];
  monthlySavingsPrAry: any[] = [];
  monthlySavingsTWTAry: any[] = [];
  showNoDataErrMsg: boolean = false;
  tableTotal: number[] = [];
  tableCPUTotalSavings: number[] = [];
  tableTotalCostTotalSavings: number[] = [];
  tableTotalSavings: number[] = [];
  tableCPUTotalSavingsNextFiscalYear: number[] = [0, 0, 0, 0, 0];
  tableTotalCostTotalSavingsNextFiscalYear: number[] = [0, 0, 0, 0, 0];
  tableCPUTotalSavingsCPU: number[] = [0, 0, 0, 0, 0];
  tableTotalSavingsCPU: number[] = [0, 0, 0, 0, 0];
  tableTotalVolume: number[] = [];
  tableTotalVolumeCurFisYear: number[] = [];
  tableTotalWorkingDays: number[] = [];
  tableTotalStandardRate: number[] = [];
  tableTotalnumberofShifts: number[] = [];
  tableTotalCapacity: number[] = [];
  tableTotalTWT: number[] = [];
  tableTotalShifts: number[] = [];
  tableTotalLineCapacity: number[] = [];
  tableTotalMonthlySavingstwt: number[] = [];
  tableTotalCPUSavingstwt: number[] = [];
  tableTotalMonthlySavings: number[] = [];
  tableTotalMonthlySavingsNextFiscalYear: number[] = [];
  tableTotalCPUSavings: number[] = [];
  tableProcessReduction: number[][] = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]];
  tableTwtReduction: number[][] = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]];
  tableTotalCost: number[][] = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]];
  tabletotalCostPerUnit: number[] = [0, 0, 0, 0, 0];
  gridMonthlySavingsPR: number[][] = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]];
  gridMonthlySavingsTWT: number[][] = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]];
  gridCPUSavingsPR: number[][] = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]];
  gridCPUSavingsTWT: number[][] = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]];
  gridTWTSavings: number[][] = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]];
  fiscalImpDateMixCPU: number[][] = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]];
  nsProcessReduction: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  nsTwtReduction: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  nsMonthlySavings: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  nsCpuSavings: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  prCumulativeSavings: number[][] = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]];
  prTWTCumulativeSavings: number[][] = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]];
  gridMonthlySavingsTWTPR: number[][] = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]];
  tblNetSavingsShow: boolean = false;
  startDate!: Date;
  selectedDate: string = "";
  implementationDate: string = "";
  savingsMeasure !: SavingsMeasure[];
  filteredSavingsMeasure !: SavingsMeasure[];
  yearlyProductFacts !: YearlyProductFacts[]
  initialLoad: boolean = true;
  accountAdded: boolean = false;
  savingsMeasureLoaded !: boolean;
  costTypesLoaded !: boolean;
  costDirectionsLoaded !: boolean;
  detailedAccountsLoaded !: boolean;
  yearlyProductFactsLoaded !: boolean;
  draftStatusWithNoAccounts: boolean = false;
  processReduction: number = 0;
  twtReduction: number = 0;
  sumtotal: number = 0;
  public kaizenMonthlySavingAry: any;
  public kaizenMonthlySavingAry2: any;
  public _totalMontlySavings: number = 0;
  public count: number = 0;
  totalCostPerUnit: number[] = [];
  totalCostCalculated: number = 0;
  totalCost: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  processReductionFy: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  twtReductionFy: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  dateHeader: string[] = [];
  selectedLabourClass: string = "";
  kaizenMonthlySaving: KaizenMonthlySaving[] = [];
  fifthFormGroup!: UntypedFormGroup;
  fifthFormValid: boolean = false;
  showDeletedAc: boolean = false;
  costDirections!: CostDirection[];
  costTypes!: CostType[];
  filteredCostTypes!: CostType[];
  filteredSavingNMeasures!: SavingsMeasure[];
  filteredDetailedAccounts !: DetailedAccount[];
  estimatedMonth!: number;
  estimatedImplementationMonthIndex!: number;
  deletedAccountString: string = '';
  detailedAccounts !: DetailedAccount[];
  fundamentalAlert: boolean = false;
  fiscalYear: string = '';
  fiscalYearEnd: number = 0;
  fyText: string = '';
  fyNextText: string = '';
  displayFiscalYear: number = 0;
  monthList = [
    { Value: 4, Text: 'Apr' },
    { Value: 5, Text: 'May' },
    { Value: 6, Text: 'Jun' },
    { Value: 7, Text: 'Jul' },
    { Value: 8, Text: 'Aug' },
    { Value: 9, Text: 'Sep' },
    { Value: 10, Text: 'Oct' },
    { Value: 11, Text: 'Nov' },
    { Value: 12, Text: 'Dec' },
    { Value: 1, Text: 'Jan' },
    { Value: 2, Text: 'Feb' },
    { Value: 3, Text: 'Mar' }
  ];
  yearList!: YearsWithCapacity[];
  operationRateYesNo: string = 'No';
  taktTimeYesNo: string = 'No';
  operationRate: boolean = false;
  taktTime: boolean = false;  
  public btnSaveforLaterMultiAc: boolean = true;
  ckNeverloaded: boolean = true;
  multipleCurrencies: boolean = false;
  currencies !: Currency[];
  currenciesLoaded !: boolean;
  isRecalc: boolean = false;

  constructor(private formBuilder: UntypedFormBuilder, private route: ActivatedRoute, private AccountService: AccountService,
    private KaizenService: KaizenService, private yearlyProductService: YearlyProductFactsService, private dialog: MatDialog,
    private CostDirectionService: CostDirectionService, private CostTypeService: CostTypeService, private DetailedAccountService: DetailedAccountService,
    private SavingMeasureService: SavingsMeasureService, private dialogAccountDeleteService: DialogaccountdeleteService,public currencyService: CurrencyService
  ) { }
  ngOnChanges(changes: SimpleChanges): void 
  {
    if(changes.CreateKaizen)
    {
      if (this.reloadKaizenId != 0) {
        this.editKaizenId = this.reloadKaizenId;
      }
      else {
        this.editKaizenId = Number(this.route.snapshot.paramMap.get('id'));
      }
      if(this.CreateKaizen.companyID != undefined && this.CreateKaizen.companyID > 0)
      { 
        this.yearlyProductService.getYearsWithCapacity(this.CreateKaizen.companyID).subscribe      
        ({ next: (data:any)=>
           {
              //console.log(data);
              this.yearList = data;
           },
           error(err:any)  { console.error('Observable emitted an error: ' + err); },                 
        });
        
      }

      this.fifthFormGroup = this.formBuilder.group({
       
        estimatedImplementationMonth: [{value: '', disabled: this.CreateKaizen.kaizenStateID != 1 }, Validators.required],
        estimatedImplementationYear: [{value: '', disabled: this.CreateKaizen.kaizenStateID != 1 }, Validators.required],
        kaizenCancelDelete: [''],
        reasonForCancellation: [''],
        kaizenComplete: [''],
        completionDay: [''],
        completionMonth: [''],
        completionYear: [''],
        submitBpaks: [''],
        accountArray: new UntypedFormArray([])
      });
      
      if(this.CreateKaizen.estimatedImplementationMonth != undefined)
      {
          var estimatedMonthInt = Number(this.CreateKaizen.estimatedImplementationMonth);
          this.estimatedImplementationMonthIndex = estimatedMonthInt < 4 ? estimatedMonthInt + 8 : estimatedMonthInt - 4;
          this.implementationDate = this.CreateKaizen.estimatedImplementationMonth + '-01-' + this.CreateKaizen.estimatedImplementationYear;                 
      }
      if (this.editKaizenId == 0) 
      {
        this.addAccount();
        this.getCostDirection();
        this.getCostType();
        this.getAccounts();
        this.getSavingsMeasures();
        this.getCurrencies();
        this.draftStatusWithNoAccounts = true;
      }
      else 
      {
        this.btnSaveforLaterMultiAc = false;
        if (this.CreateKaizen.estimatedImplementationYear && this.CreateKaizen.estimatedImplementationYear != '0') {
          this.selectedDate = this.getFiscalYear(new Date(this.CreateKaizen.estimatedImplementationYear + '-' + this.CreateKaizen.estimatedImplementationMonth + '-1'));
          this.displayFiscalYear = this.displayGetFiscalYear(Number(this.CreateKaizen.estimatedImplementationMonth), Number(this.CreateKaizen.estimatedImplementationYear));
        }
        if (this.editKaizenId == 0) 
        {
          this.addAccount();
          this.getCostDirection();
          this.getCostType();
          this.getAccounts();
          this.getSavingsMeasures();
          this.getCurrencies();
          this.draftStatusWithNoAccounts = true;        
        }
        else 
        {
          this.btnSaveforLaterMultiAc = false;
          //In some instances the Month and/or Year can be zero and we do not want to set the control value to zero because the default text will not
          //be displayed.  It is displayed when the value is empty string, so if it is zero set it to empty string
          var month = this.CreateKaizen.estimatedImplementationMonth == '0' ? '' : this.CreateKaizen.estimatedImplementationMonth;
          var year = this.CreateKaizen.estimatedImplementationYear == '0' ? '' : this.CreateKaizen.estimatedImplementationYear;
          this.fifthFormGroup.controls['estimatedImplementationMonth'].setValue(month);
          this.fifthFormGroup.controls['estimatedImplementationYear'].setValue(year);
          
          if (this.CreateKaizen.estimatedImplementationYear && this.CreateKaizen.estimatedImplementationYear != '0') {
            this.selectedDate = this.getFiscalYear(new Date(this.CreateKaizen.estimatedImplementationYear + '-' + this.CreateKaizen.estimatedImplementationMonth + '-1'));
            this.displayFiscalYear = this.displayGetFiscalYear(Number(this.CreateKaizen.estimatedImplementationMonth), Number(this.CreateKaizen.estimatedImplementationYear));
          }
        }
        if (this.editKaizenId == 0) {
          this.editKaizenId = this.reloadKaizenId;
        }
        if (this.editKaizenId != 0) 
        {
          if (this.CreateKaizen != undefined && this.ckNeverloaded) 
          {
            this.fifthFormGroup = this.formBuilder.group({
              estimatedImplementationMonth: ['', Validators.required],
              estimatedImplementationYear: ['', Validators.required],
              kaizenCancelDelete: [''],
              reasonForCancellation: [''],
              kaizenComplete: [''],
              completionDay: [''],
              completionMonth: [''],
              completionYear: [''],
              submitBpaks: [''],
              accountArray: new UntypedFormArray([])
            });
            this.initLoadExistingKaizen();

            this.ckNeverloaded = false;
          }
        }
      }
    }
     this.fiscalYear = this.getFiscalYear(new Date(this.CreateKaizen.estimatedImplementationMonth+'-01-' + this.CreateKaizen.estimatedImplementationYear));
    this.displayFiscalYear = this.displayGetFiscalYear(Number(this.CreateKaizen.estimatedImplementationMonth), Number(this.CreateKaizen.estimatedImplementationYear));
   }
   
  async initLoadExistingKaizen() 
  {
    await this.getCostDirection();
    await this.getCurrencies();
    await firstValueFrom(this.AccountService.getAccounts(localStorage.getItem('ademail')!)).then((data) => {
      this.accounts = data?.data || [] ;
      this.accountsLoaded = true;
    });
    await firstValueFrom(this.KaizenService.getKaizenMonthlySaving(this.editKaizenId)).then((data) => {
        this.kaizenMonthlySavingsList = data ?? new PRKaizenMonthlySavingsList();;
        if (data?.data || [] .length == 0) {
          this.draftStatusWithNoAccounts = true;
        }
        console.log(`incoming ms`, this.kaizenMonthlySavingsList.data);
      });
    await firstValueFrom(this.KaizenService.getKaizenAccountsByKaizenId(this.editKaizenId)).then((data) => {
      this.kaizenAccountArray = data;
      console.log('incoming ka  data this.editKaizenId='+this.editKaizenId, data);

      console.log('incoming ka ', this.kaizenAccountArray.data);
      if (this.kaizenAccountArray.data.length > 0) {
        for (var i = 0; i <= this.kaizenAccountArray.data.length - 1; i++) {
          this.getCostTypeForEdit(this.kaizenAccountArray.data[i].costDirectionId, i);
          if (this.kaizenAccountArray.data[i].glAccountImpactAreaId != null) {
            this.getDetailedAccountsForEdit(this.kaizenAccountArray.data[i].glAccountImpactAreaId, i);
          }
          this.getSavingsMeasuresForEdit(this.kaizenAccountArray.data[i].savingsMeasureId, i);
          this.showTotalCostTable[i] = false;
          this.showCostPerUnitTable[i] = false;
          this.showProcessReductionTable[i] = false;
          this.showTotalWorkingTimeReductionTable[i] = false;
          if (this.kaizenAccountArray.data[i].savingsMeasureId == 2) { // Process Reduction 
            this.monthlySavingsPrAry = this.kaizenMonthlySavingsList.data.filter(x => x.kaizenAccountId == this.kaizenAccountArray.data[i].kaizenAccountId);
            this.showProcessReductionTable[i] = true;
            for (var j = 0; j <= 11; j++) {
              this.tableProcessReduction[i][j] = this.monthlySavingsPrAry[j].processReduction;
            }
          }
          else if (this.kaizenAccountArray.data[i].savingsMeasureId == 3) { // Total Working Time Reduction 
            this.monthlySavingsTWTAry = this.kaizenMonthlySavingsList.data.filter(x => x.kaizenAccountId == this.kaizenAccountArray.data[i].kaizenAccountId);
            this.showTotalWorkingTimeReductionTable[i] = true;
            for (var j = 0; j <= 11; j++) {
              this.tableTwtReduction[i][j] = this.monthlySavingsTWTAry[j].twtReduction;
            }
          }
          else if (this.kaizenAccountArray.data[i].savingsMeasureId == 4) { // Cost Per Unit 
            this.showCostPerUnitTable[i] = true;
            this.tabletotalCostPerUnit[i] = this.kaizenAccountArray.data[i].costPerUnit;
          }
          else if (this.kaizenAccountArray.data[i].savingsMeasureId == 5) { // Total Cost
            this.showTotalCostTable[i] = true;
          }
          if (i > 1) {
            this.tblNetSavingsShow = true;
          }
          this.loadAccount(i);
        }
      }
    }
    );
    if (this.selectedDate) {
      await this.netSavingsTableCalculations();
      await this.netSavingsTableCalculationsNewAc();
    }
  }
  async getYearlyProductFactsForAccount(accountText: string, accountNumber: number, savingsMeasure: number) {
    let startDate = this.selectedDate;
    if (accountText == 'A Labour') {
      this.labourcls[accountNumber] = "A";
    }
    else if (accountText == 'B1 Labour') {
      this.labourcls[accountNumber] = "B1";
    }
    else if (accountText == 'B2 Labour') {
      this.labourcls[accountNumber] = "B2";
    }
    else if (accountText == 'C1 Labour') {
      this.labourcls[accountNumber] = "C1";
    }
    else if (accountText == 'C2 Labour') {
      this.labourcls[accountNumber] = "C2";
    }
    else {
      this.labourcls[accountNumber] = "";
    }

    if (this.CreateKaizen.kaizenImpactingModelID == 1) {
      await this.getYearlyProductFacts(this.CreateKaizen.companyID, startDate, this.labourcls[accountNumber], this.CreateKaizen.kaizenImpactingModelID, 0, this.CreateKaizen.companyID, accountNumber);
    }
    else if (this.CreateKaizen.kaizenImpactingModelID == 2) {
      await this.getYearlyProductFacts(this.CreateKaizen.lineID, startDate, this.labourcls[accountNumber], this.CreateKaizen.kaizenImpactingModelID, 0, this.CreateKaizen.companyID, accountNumber);
    }
    else if (this.CreateKaizen.kaizenImpactingModelID == 3) {
      await this.getYearlyProductFacts(this.CreateKaizen.shopID, startDate, this.labourcls[accountNumber], this.CreateKaizen.kaizenImpactingModelID, 0, this.CreateKaizen.companyID, accountNumber);
    }
    else if (this.CreateKaizen.kaizenImpactingModelID == 4) {
      await this.getYearlyProductFacts(this.CreateKaizen.vehicleModelID, startDate, this.labourcls[accountNumber], this.CreateKaizen.kaizenImpactingModelID, this.CreateKaizen.shopID, this.CreateKaizen.companyID, accountNumber);
    }
    
  }
  async netSavingsTableCalculationsNewAc() {   // NET SAVINGS Calculations
    let twtIncrease: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let twtDecrease: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let pReductionIncrease: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let pReductionDecrease: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let monthlySavingsRate: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let monthlySavingsIncrease: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let monthlySavingsDecrease: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let kacl: KaizenAccountList = new KaizenAccountList();
    console.log('ac ary', this.accountArray.getRawValue());
    if (this.accountArray.length > 0) {
      for (var i = 0; i < this.accountArray.getRawValue().length; i++) {
        kacl.accountsText = this.accounts.find(x => x.glAccountImpactAreaId == this.accountArray.getRawValue()[i].gLAccountImpactAreaID)?.name;
        this.getYearlyProductFactsForAccount('' + kacl.accountsText, i, this.accountArray.getRawValue()[i].savingsMeasureID);
        if (this.accountArray.getRawValue()[i].savingsMeasureID == 2) { //Proceess Redution
          if (this.accountArray.getRawValue()[i].costDirectionID == 1) { // Decrease
            for (var j = 0; j <= 11; j++) {
              pReductionDecrease[j] += this.tableProcessReduction[i][j];
            }
          }
          else if (this.accountArray.getRawValue()[i].costDirectionID == 3) { // Increase
            for (var j = 0; j <= 11; j++) {
              pReductionIncrease[j] += this.tableProcessReduction[i][j];
            }
          }
          for (var j = 0; j <= 11; j++) {
            monthlySavingsRate[j] = 0;
            monthlySavingsRate[j] = this.tableProcessReduction[i][j];
          }
        }
        if (this.accountArray.getRawValue()[i].savingsMeasureID == 3) { // TWT
          if (this.accountArray.getRawValue()[i].costDirectionID == 1) { // Decrease
            for (var j = 0; j <= 11; j++) {
              twtDecrease[j] += Number(this.tableTwtReduction[i][j]);
            }
          }
          else if (this.accountArray.getRawValue()[i].costDirectionID == 3) { // Increase
            for (var j = 0; j <= 11; j++) {
              twtIncrease[j] += Number(this.tableTwtReduction[i][j]);
            }
          }
          for (var j = 0; j <= 11; j++) {
            monthlySavingsRate[j] = 0;
            monthlySavingsRate[j] = this.tableTwtReduction[i][j];
          }
        }
        if (this.accountArray.getRawValue()[i].savingsMeasureID == 4) { // cost per unit
          if (this.accountArray.getRawValue()[i] != 0) {
            for (var j = 0; j <= 11; j++) {
              monthlySavingsRate[j] = 0;
              monthlySavingsRate[j] = this.accountArray.getRawValue()[i].costPerUnit;
            }
          }
        }        //        console.log(`this.yearlyProductFactsAcAry`, this.yearlyProductFactsAcAry);
        for (var monthIndex = 0; monthIndex < 12; monthIndex++) {
          if (this.accountArray.getRawValue()[i].costDirectionID == 1) { // Decrease
            if (this.accountArray.getRawValue()[i].savingsMeasureID == 5) {
              monthlySavingsDecrease[monthIndex] += this.accountArray.getRawValue()[i].totalCost[monthIndex];
            }
            else if (this.accountArray.getRawValue()[i].savingsMeasureID == 4) {
              monthlySavingsDecrease[monthIndex] += this.yearlyProductFactsAcAry[i][monthIndex].modelVolume * monthlySavingsRate[monthIndex] * this.fiscalImpDateMixCPU[i][monthIndex];
            }
            else if (this.accountArray.getRawValue()[i].savingsMeasureID == 2) {            
              monthlySavingsDecrease[monthIndex] += this.prCumulativeSavings[i][monthIndex];
            }
            else if (this.accountArray.getRawValue()[i].savingsMeasureID == 3) {
              monthlySavingsDecrease[monthIndex] += this.yearlyProductFactsAcAry[i][monthIndex].standardRate * this.yearlyProductFactsAcAry[i][monthIndex].workingDays * this.yearlyProductFactsAcAry[i][monthIndex].numberOfShifts * this.tableTwtReduction[i][monthIndex];
            }
          }
          else if (this.accountArray.getRawValue()[i].costDirectionID == 3) { // Increase
            if (this.accountArray.getRawValue()[i].savingsMeasureID == 5) {
              monthlySavingsIncrease[monthIndex] += this.accountArray.getRawValue()[i].totalCost[monthIndex];
            }
            else if (this.accountArray.getRawValue()[i].savingsMeasureID == 4) {
              monthlySavingsIncrease[monthIndex] += this.yearlyProductFactsAcAry[i][monthIndex].modelVolume * monthlySavingsRate[monthIndex] * this.fiscalImpDateMixCPU[i][monthIndex];
            }
            else if (this.accountArray.getRawValue()[i].savingsMeasureID == 2) {              
              monthlySavingsIncrease[monthIndex] += this.prCumulativeSavings[i][monthIndex];
            }
            else if (this.accountArray.getRawValue()[i].savingsMeasureID == 3) {
              monthlySavingsIncrease[monthIndex] += this.yearlyProductFactsAcAry[i][monthIndex].standardRate * this.yearlyProductFactsAcAry[i][monthIndex].workingDays * this.yearlyProductFactsAcAry[i][monthIndex].numberOfShifts * this.tableTwtReduction[i][monthIndex];
            }
          }
        }
      }
      for (var netSavingsIndex = 0; netSavingsIndex < 12; netSavingsIndex++) {
        this.nsMonthlySavings[netSavingsIndex] = Number((monthlySavingsDecrease[netSavingsIndex] - monthlySavingsIncrease[netSavingsIndex]).toFixed(2));
      }
      for (var monthIndex = 0; monthIndex < 12; monthIndex++) {
        this.nsCpuSavings[monthIndex] = Number(((monthlySavingsDecrease[monthIndex] - monthlySavingsIncrease[monthIndex]) / this.yearlyProductFactsAcAry[0][monthIndex].modelVolume).toFixed(2));
      }
      for (var monthIndex = 0; monthIndex < 12; monthIndex++) {
        this.nsProcessReduction[monthIndex] = pReductionDecrease[monthIndex] - pReductionIncrease[monthIndex];
        this.nsTwtReduction[monthIndex] = twtDecrease[monthIndex] - twtIncrease[monthIndex];
      }
      if (this.accountArray.length > 1) {
        this.tblNetSavingsShow = true;
      }
      else {
        this.tblNetSavingsShow = false;
      }
    }
  }
  async netSavingsTableCalculations() {
    console.log('netsv--->', this.kaizenAccountArray.data.length);
    let kacl: KaizenAccountList = new KaizenAccountList();
    if (this.kaizenAccountArray.data.length > 0) {
      for (var i = 0; i <= this.kaizenAccountArray.data.length - 1; i++) {
        let startDate = this.selectedDate;
        kacl.accountsText = this.accounts.find(x => x.glAccountImpactAreaId == this.kaizenAccountArray.data[i].glAccountImpactAreaId)?.name;
        if (kacl.accountsText == 'A Labour') {
          this.labourcls[i] = "A";
        }
        else if (kacl.accountsText == 'B1 Labour') {
          this.labourcls[i] = "B1";
        }
        else if (kacl.accountsText == 'B2 Labour') {
          this.labourcls[i] = "B2";
        }
        else if (kacl.accountsText == 'C1 Labour') {
          this.labourcls[i] = "C1";
        }
        else if (kacl.accountsText == 'C2 Labour') {
          this.labourcls[i] = "C2";
        }
        else {
          this.labourcls[i] = "";
        }
        if (this.CreateKaizen.kaizenImpactingModelID == 1) {
          await firstValueFrom(this.yearlyProductService.getYearlyProductFacts(this.CreateKaizen.companyID, startDate, this.labourcls[i], this.CreateKaizen.kaizenImpactingModelID, 0, this.CreateKaizen.companyID)
            ).then((data) => {
              this.yearlyProductFacts = data?.data || [] ;
              this.yearlyProductFactsLoaded = true;
              this.yearlyProductFactsAcAry[i] = data?.data || [] ;
              this.cPuProductFactsAcAry[i] = data?.data || [] ;
              this.calcTableTotal(i);
            });
        }
        else if (this.CreateKaizen.kaizenImpactingModelID == 2) {
          await firstValueFrom(this.yearlyProductService.getYearlyProductFacts(this.CreateKaizen.lineID, startDate, this.labourcls[i], this.CreateKaizen.kaizenImpactingModelID, 0, this.CreateKaizen.companyID)
            ).then((data) => {
              this.yearlyProductFacts = data?.data || [] ;
              this.yearlyProductFactsLoaded = true;
              this.yearlyProductFactsAcAry[i] = data?.data || [] ;
              this.cPuProductFactsAcAry[i] = data?.data || [] ;
              this.calcTableTotal(i);
            });
        }
        else if (this.CreateKaizen.kaizenImpactingModelID == 3) {
          await firstValueFrom(this.yearlyProductService.getYearlyProductFacts(this.CreateKaizen.shopID, startDate, this.labourcls[i], this.CreateKaizen.kaizenImpactingModelID, 0, this.CreateKaizen.companyID)
            ).then((data) => {
              this.yearlyProductFacts = data?.data || [] ;
              this.yearlyProductFactsLoaded = true;
              this.yearlyProductFactsAcAry[i] = data?.data || [] ;
              this.cPuProductFactsAcAry[i] = data?.data || [] ;
              this.calcTableTotal(i);
            });
        }
        else if (this.CreateKaizen.kaizenImpactingModelID == 4) {
          await firstValueFrom(this.yearlyProductService.getYearlyProductFacts(this.CreateKaizen.vehicleModelID, startDate, this.labourcls[i], this.CreateKaizen.kaizenImpactingModelID, this.CreateKaizen.shopID, this.CreateKaizen.companyID)
            ).then((data) => {
              this.yearlyProductFacts = data?.data || [] ;
              this.yearlyProductFactsLoaded = true;
              this.yearlyProductFactsAcAry[i] = data?.data || [] ;
              this.cPuProductFactsAcAry[i] = data?.data || [] ;
              this.calcTableTotal(i);
            });
        }
        // if (this.kaizenAccountArray.data[i].savingsMeasureId == 4) {
        //   await firstValueFrom(this.yearlyProductService.getYearlyProductFacts(this.CreateKaizen.companyID, startDate, this.labourcls[i], this.CreateKaizen.kaizenImpactingModelID, 0, this.CreateKaizen.companyID)
        //     ).then((data) => {
        //       this.yearlyProductFacts = data.data;
        //       this.yearlyProductFactsLoaded = true;
        //       this.yearlyProductFactsAcAry[i] = data.data;
        //       this.calcTableTotal(i);
        //     });
        //   await firstValueFrom(this.yearlyProductService.getYearlyProductFacts(this.CreateKaizen.companyID, this.implementationDate, this.labourcls[i], this.CreateKaizen.kaizenImpactingModelID, 0, this.CreateKaizen.companyID)
        //).then((data) => {
        //       this.cPuProductFactsAcAry[i] = data.data;
        //       this.calcTableTotal(i);
        //     });
        // }
        if (this.kaizenAccountArray.data[i].savingsMeasureId == 5) {
          this.KaizenMonthlySavingAccountsAry = this.kaizenMonthlySavingsList.data.filter(x => x.kaizenAccountId == this.kaizenAccountArray.data[i].kaizenAccountId);
        }
      }
    }
    let twtIncrease: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let twtDecrease: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let pReductionIncrease: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let pReductionDecrease: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let monthlySavingsIncrease: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let monthlySavingsDecrease: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    if (this.kaizenAccountArray && this.kaizenAccountArray.data.length > 0 && !this.draftStatusWithNoAccounts) {
      for (var i = 0; i <= this.kaizenAccountArray.data.length - 1; i++) {
        if (this.kaizenAccountArray.data[i].savingsMeasureId == 2) { //Proceess Redution
          if (this.kaizenAccountArray.data[i].costDirectionId == 1) { // Decrease
            for (var j = 0; j <= 11; j++) {
              pReductionDecrease[j] += Number(this.tableProcessReduction[i][j]);
            }
          }
          else if (this.kaizenAccountArray.data[i].costDirectionId == 3) { // Increase
            for (var j = 0; j <= 11; j++) {
              pReductionIncrease[j] += Number(this.tableProcessReduction[i][j]);
            }
          }
         
        }
        if (this.kaizenAccountArray.data[i].savingsMeasureId == 3) { // TWT
          if (this.kaizenAccountArray.data[i].costDirectionId == 1) { // Decrease
            for (var j = 0; j <= 11; j++) {
              twtDecrease[j] += Number(this.tableTwtReduction[i][j]);
            }
          }
          else if (this.kaizenAccountArray.data[i].costDirectionId == 3) { // Increase
            for (var j = 0; j <= 11; j++) {
              twtIncrease[j] += Number(this.tableTwtReduction[i][j]);
            }
          }
        }
        this.kaizenMonthlySavingAry = this.kaizenMonthlySavingsList.data.filter(x => x.kaizenAccountId == this.kaizenAccountArray.data[i].kaizenAccountId);
        for (var monthIndex = 0; monthIndex < 12; monthIndex++) 
        {
          if (this.kaizenAccountArray.data[i].savingsMeasureId == 2) 
          {
            if (this.kaizenAccountArray.data[i].costDirectionId == 1) 
            {
              monthlySavingsDecrease[monthIndex] += this.prCumulativeSavings[i][monthIndex];
            }
            else if (this.kaizenAccountArray.data[i].costDirectionId == 3) 
            {
              monthlySavingsIncrease[monthIndex] += this.prCumulativeSavings[i][monthIndex];
            }
          }
          else {
            if (this.kaizenAccountArray.data[i].costDirectionId == 1) {
              monthlySavingsDecrease[monthIndex] += this.kaizenMonthlySavingAry[monthIndex].monthlySavings;
            }
            else if (this.kaizenAccountArray.data[i].costDirectionId == 3) {
              monthlySavingsIncrease[monthIndex] += this.kaizenMonthlySavingAry[monthIndex].monthlySavings;
            }
          }
        } 
      }
      for (var netSavingsIndex = 0; netSavingsIndex < 12; netSavingsIndex++) {
        this.nsMonthlySavings[netSavingsIndex] = Number((monthlySavingsDecrease[netSavingsIndex] - monthlySavingsIncrease[netSavingsIndex]).toFixed(2));
      }
      for (var i = 0; i <= this.kaizenAccountArray.data.length - 1; i++) {
        for (var monthIndex = 0; monthIndex < 12; monthIndex++) {
          this.nsCpuSavings[monthIndex] = Number(((monthlySavingsDecrease[monthIndex] - monthlySavingsIncrease[monthIndex]) / this.yearlyProductFactsAcAry[i][monthIndex].modelVolume).toFixed(2));
        }
      }
      for (var j = 0; j <= 11; j++) {
        this.nsProcessReduction[j] = pReductionDecrease[j] - pReductionIncrease[j];
        this.nsTwtReduction[j] = twtDecrease[j] - twtIncrease[j];
      }
      if (this.kaizenAccountArray.data.length > 1) {
        this.tblNetSavingsShow = true;
      }
    }
  }
  createAccount(): UntypedFormGroup {
    for (var j = 0; j <= 11; j++) {
      const kms: KaizenMonthlySaving = {
        kaizenMonthlySavingId: 0,
        CalendarMonthID: 0,
        WorkingDays: 0,
        WorkingHours: '0',
        NumberOfShifts: 0,
        StandardRate: 0,
        Capacity: 0,
        MonthHead: 'createac',
        MonthlySavings: 0,
        costPerUnitSavings: 0,
        processReduction: 0,
        twtReduction: 0
      }
      this.kaizenMonthlySaving[j] = kms;
    }
  
    return this.formBuilder.group(
      {
        kaizenAccountId: 0,
        kaizenId: this.editKaizenId,
        costDirectionID: [null, Validators.required],
        costTypeID: [null, Validators.required],
        gLAccountImpactAreaID: [null, Validators.required],
        detailedAccountId: [null],
        savingsMeasureID: [null, Validators.required],
        operationRate: [false],
        taktTime: [false],
        costPerUnit: [0],
        totalCostMon0: [0],
        totalCostMon1: [0],
        totalCostMon2: [0],
        totalCostMon3: [0],
        totalCostMon4: [0],
        totalCostMon5: [0],
        totalCostMon6: [0],
        totalCostMon7: [0],
        totalCostMon8: [0],
        totalCostMon9: [0],
        totalCostMon10: [0],
        totalCostMon11: [0],
        totalCost: this.formBuilder.array(this.totalCost),
        totalCost12Months: [0],
        kaizenMonthlySaving: this.formBuilder.array(this.kaizenMonthlySaving),
        processReductionMon0: [0],
        processReductionMon1: [0],
        processReductionMon2: [0],
        processReductionMon3: [0],
        processReductionMon4: [0],
        processReductionMon5: [0],
        processReductionMon6: [0],
        processReductionMon7: [0],
        processReductionMon8: [0],
        processReductionMon9: [0],
        processReductionMon10: [0],
        processReductionMon11: [0],
        processReductionMaster: [0],
        twtReductionMaster: [0],
        twtReductionMon0: [0],
        twtReductionMon1: [0],
        twtReductionMon2: [0],
        twtReductionMon3: [0],
        twtReductionMon4: [0],
        twtReductionMon5: [0],
        twtReductionMon6: [0],
        twtReductionMon7: [0],
        twtReductionMon8: [0],
        twtReductionMon9: [0],
        twtReductionMon10: [0],
        twtReductionMon11: [0],
        nextFYTotalSavings: [0],
        averageCPUSavings: [0],
        totalSavings: [0],
        totalVolume: [0],
        currencyId: 1
      });
  }
  addAccount(): void {
    this.accountAdded = true;
    this.showNoDataErrMsg = false;
    this.accountArray = this.fifthFormGroup.get('accountArray') as UntypedFormArray;
    this.accountArray.push(this.createAccount());
    let i = this.accountArray.length;
    this.showTotalCostTable[i - 1] = false;
    this.showCostPerUnitTable[i - 1] = false;
    this.showProcessReductionTable[i - 1] = false;
    this.showTotalWorkingTimeReductionTable[i - 1] = false;
    for (var j = 0; j <= 11; j++) {
      this.tableProcessReduction[i - 1][j] = 0;
      this.tableTwtReduction[i - 1][j] = 0;
    }
    this.tabletotalCostPerUnit[i - 1] = 0;
    this.fifthFormValid = false;
    this.emitAccounts();
  }
  addAccountButtonClick(): void {
    if (this.CreateKaizen.kaizenStateID == 2 && this.draftStatusWithNoAccounts == true) {
      this.draftStatusWithNoAccounts = false;
    }
    this.addAccount();
  }
  public deletedAccountsExist: boolean = false;
  deleteAccount(i: number) {
    let deleteActuals: boolean = false;
    if (this.kaizenAccountArray.data != undefined) {
      if (this.kaizenAccountArray && this.kaizenAccountArray.data && this.kaizenAccountArray.data[0].nonZeroActualsCount > 0) {
        const deleteActualsConfirmDialog = this.dialog.open
          (DialogDeleteAccountWithActualsConfirmComponent,
            {
              width: '40%'
            }
          );
        deleteActualsConfirmDialog.afterClosed().subscribe(result => {
          deleteActuals = result;
          if (deleteActuals) {
            this.performAccountDelete(i)
          }
          else {
            return;
          }
        })
      }
    else {
      this.performAccountDelete(i)
    }
  }
  else {
    this.performAccountDelete(i);
  }
  this.fifthFormValid = true;
  this.emitAccounts();
  }
  performAccountDelete(i: number) {
    this.reApprovalReq = true;
    this.accountArray = this.fifthFormGroup.get('accountArray') as UntypedFormArray;
    if (this.accountArray.getRawValue()[i].costDirectionID != null
      && this.accountArray.getRawValue()[i].costTypeID != null
      && this.accountArray.getRawValue()[i].gLAccountImpactAreaID != null
      && this.accountArray.getRawValue()[i].savingsMeasureID != null
    ) {
      let strAcs = '<b>Account #' + Number(i + 1) + '</b>';
      strAcs += '<br>Cost Direction: ' + this.costDirections.filter(x => x.costDirectionID == this.accountArray.getRawValue()[i].costDirectionID)[0].name;
      strAcs += ', Cost Type: ' + this.costTypes.filter(x => x.costTypeID == this.accountArray.getRawValue()[i].costTypeID)[0].name;
      strAcs += ', Account: ' + this.accounts.filter(x => x.glAccountImpactAreaId == this.accountArray.getRawValue()[i].gLAccountImpactAreaID)[0].name;
      if (this.accountArray.getRawValue()[i].detailedAccountId != null) {
        strAcs += ', Account Detail: ' + this.detailedAccounts.filter(x => x.detailedAccountID == this.accountArray.getRawValue()[i].detailedAccountId)[0].detailedAccountName;
      }
      strAcs += ', Savings Measure: ' + this.savingsMeasure.filter(x => x.savingsMeasureID == this.accountArray.getRawValue()[i].savingsMeasureID)[0].savingsMeasureName;
      if (this.accountArray.getRawValue()[i].savingsMeasureID == 2) {
        strAcs += ', Process Reduction : ' + this.accountArray.getRawValue()[i].processReduction;
        strAcs += ', Tak Time : ' + this.accountArray.getRawValue()[i].taktTime;
        strAcs += ', Operation Rate : ' + this.accountArray.getRawValue()[i].operationRate;
      }
      if (this.accountArray.getRawValue()[i].savingsMeasureID == 3) {
        strAcs += ', TWT Reduction : ' + this.accountArray.getRawValue()[i].TWTReduction;
        strAcs += ', Tak Time : ' + this.accountArray.getRawValue()[i].taktTime;
        strAcs += ', Operation Rate : ' + this.accountArray.getRawValue()[i].operationRate;
      }
      if (this.accountArray.getRawValue()[i].savingsMeasureID == 4) {
        strAcs += ', Cost Per Unit : ' + this.accountArray.getRawValue()[i].costPerUnit;
      }
      if (this.accountArray.getRawValue()[i].savingsMeasureID == 5) {
        strAcs += ', Total Cost Month 1 : ' + this.accountArray.getRawValue()[i].totalCostMon0;
        strAcs += ', Total Cost Month 2 : ' + this.accountArray.getRawValue()[i].totalCostMon1;
        strAcs += ', Total Cost Month 3 : ' + this.accountArray.getRawValue()[i].totalCostMon2;
        strAcs += ', Total Cost Month 4 : ' + this.accountArray.getRawValue()[i].totalCostMon3;
        strAcs += ', Total Cost Month 5 : ' + this.accountArray.getRawValue()[i].totalCostMon4;
        strAcs += ', Total Cost Month 6 : ' + this.accountArray.getRawValue()[i].totalCostMon5;
        strAcs += ', Total Cost Month 7 : ' + this.accountArray.getRawValue()[i].totalCostMon6;
        strAcs += ', Total Cost Month 8 : ' + this.accountArray.getRawValue()[i].totalCostMon7;
        strAcs += ', Total Cost Month 9 : ' + this.accountArray.getRawValue()[i].totalCostMon8;
        strAcs += ', Total Cost Month 10 : ' + this.accountArray.getRawValue()[i].totalCostMon9;
        strAcs += ', Total Cost Month 11 : ' + this.accountArray.getRawValue()[i].totalCostMon10;
        strAcs += ', Total Cost Month 12 : ' + this.accountArray.getRawValue()[i].totalCostMon11;
      }
      if (this.deletedAccountString == '') {
        this.deletedAccountString = '' + strAcs;
      }
      else {
        this.deletedAccountString += '<br><br>' + strAcs;
      }
    }
    this.accountArray.removeAt(i);
    this.btnAddAccountShow[i - 1] = true;
    this.accountCounter--;
    this.deletedAccountsExist = true;
    for (var j = i; j < 3; j++) {
      this.showTotalCostTable[j] = this.showTotalCostTable[j + 1];
      this.showCostPerUnitTable[j] = this.showCostPerUnitTable[j + 1];
      this.showProcessReductionTable[j] = this.showProcessReductionTable[j + 1];
      this.showTotalWorkingTimeReductionTable[j] = this.showTotalWorkingTimeReductionTable[j + 1];
      this.tableProcessReduction[j] = this.tableProcessReduction[j + 1];
      this.tableTwtReduction[j] = this.tableTwtReduction[j + 1];
      this.tabletotalCostPerUnit[j] = this.tabletotalCostPerUnit[j + 1];
    }
    this.showTotalCostTable[4] = false;
    this.showCostPerUnitTable[4] = false;
    this.showProcessReductionTable[4] = false;
    this.showTotalWorkingTimeReductionTable[4] = false;
    for (var j = 0; j <= 11; j++) {
      this.tableProcessReduction[4][j] = 0;
      this.tableTwtReduction[4][j] = 0;
    }
    this.tabletotalCostPerUnit[4] = 0;
    this.netSavingsTableCalculationsNewAc();
  }
  loadAccount(i: number): void {
    this.accountArray = this.fifthFormGroup.get('accountArray') as UntypedFormArray;
    this.accountArray.push(this.loadAccountWithPara(i));
    if (this.accountCounter == 0) {
      this.btnAddAccountShow[0] = true;
    }
    else {
      this.btnAddAccountShow[this.accountCounter - 1] = false;
      this.btnAddAccountShow[this.accountCounter] = true;
    }
    this.accountCounter++;
  }
  loadAccountWithPara(i: number): UntypedFormGroup {
    let tcCounter: number = 0;
    for (var j = 0; j <= 11; j++) {
      const kms: KaizenMonthlySaving = {
        kaizenMonthlySavingId: 0,
        CalendarMonthID: 0,
        WorkingDays: 0,
        WorkingHours: '0',
        NumberOfShifts: 0,
        StandardRate: 0,
        Capacity: 0,
        MonthHead: 'loadac',
        MonthlySavings: 0,
        costPerUnitSavings: 0,
        processReduction: 0,
        twtReduction: 0
      }
      this.kaizenMonthlySaving[j] = kms;
    }
    if (this.kaizenAccountArray.data[i].savingsMeasureId == 5) {
      tcCounter = 0;
      this.KaizenService.getKaizenMonthlySavingByKaizenAccountId(this.kaizenAccountArray.data[i].kaizenAccountId)
        .subscribe(
          data => {
            this.kaizenMonthlySavingAry = data.data;
            this.kTotalCostAry = data;
            this._totalMontlySavings = 0;
            for (const ms of this.kaizenMonthlySavingAry) {
              this.totalCost[tcCounter] = ms.monthlySavings;
              this.tableTotalCost[i][tcCounter] = ms.monthlySavings;
              const newstr = 'totalCostMon' + (tcCounter).toString();
              ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get(newstr)?.patchValue(ms.monthlySavings);
              this._totalMontlySavings += ms.monthlySavings;
              this.populateMonthlySavingsTCpu(ms.monthlySavings, 0, tcCounter, i, false);
              tcCounter++;
            }
            this.tableTotalCostTotalSavings[i] = this._totalMontlySavings;
            ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('totalCost12Months')?.patchValue(this._totalMontlySavings);
            ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('totalCost')?.patchValue(this.totalCost);
            ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('kaizenMonthlySaving')?.patchValue(this.kaizenMonthlySavingAry);
          }
        );
    }
    if (this.kaizenAccountArray.data[i].savingsMeasureId == 4) {
      tcCounter = 0;
      this.KaizenService.getKaizenMonthlySavingByKaizenAccountId(this.kaizenAccountArray.data[i].kaizenAccountId)
        .subscribe(
          data => {
            this.kaizenMonthlySavingAry = data.data;
            for (const ms of this.kaizenMonthlySavingAry) {
              this.populateMonthlySavingsTCpu(0, ms.monthlySavings, tcCounter, i, false);
              tcCounter++;
            }
            this.setFiscalImpDateMixCPU(i);
            ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('kaizenMonthlySaving')?.patchValue(this.kaizenMonthlySavingAry);
          }
        );
    }
    if (this.kaizenAccountArray.data[i].savingsMeasureId == 2) {
      tcCounter = 0;
      this.KaizenService.getKaizenMonthlySavingByKaizenAccountId(this.kaizenAccountArray.data[i].kaizenAccountId)
        .subscribe(
          data => {
            this.kaizenMonthlySavingAry = data.data;
            for (const ms of this.kaizenMonthlySavingAry) {
              const newstr = 'processReductionMon' + (tcCounter).toString();
              ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get(newstr)?.patchValue(ms.processReduction);
              this.populateMonthlySavings(ms.processReduction, 0, tcCounter, i, false);
              tcCounter++;
            }
            ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('kaizenMonthlySaving')?.patchValue(this.kaizenMonthlySavingAry);
          }
        );
    }
    if (this.kaizenAccountArray.data[i].savingsMeasureId == 3) {
      tcCounter = 0;
      this.KaizenService.getKaizenMonthlySavingByKaizenAccountId(this.kaizenAccountArray.data[i].kaizenAccountId)
        .subscribe(
          data => {
            this.kaizenMonthlySavingAry = data.data;
            for (const ms of this.kaizenMonthlySavingAry) {
              const newstr = 'twtReductionMon' + (tcCounter).toString();
              ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get(newstr)?.patchValue(ms.twtReduction);
              this.populateMonthlySavings(0, ms.twtReduction, tcCounter, i, false);
              tcCounter++;
            }
            ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('kaizenMonthlySaving')?.patchValue(this.kaizenMonthlySavingAry);
          }
        );
    }
    this.filteredCostTypeArray[i] = this.costTypes;
    this.filteredAccountsArray[i] = this.accounts;
    // this.filteredCostCentersArray[i] = this.costCenters;
    this.filteredDetailedAccountsArray[i] = this.detailedAccounts;
    this.filteredSavingNMeasuresArray[i] = this.savingsMeasure;
    var disableDropdown: boolean = false;
    //If these are all populated then the account exists, if not then it is a placeholder account
    if (this.kaizenAccountArray.data[i].costDirectionId
      && this.kaizenAccountArray.data[i].costTypeId
      && this.kaizenAccountArray.data[i].glAccountImpactAreaId
      && this.kaizenAccountArray.data[i].savingsMeasureId
    ) {
      disableDropdown = true;
    }
    return this.formBuilder.group(
      {
        kaizenAccountId: [this.kaizenAccountArray.data[i].kaizenAccountId],
        kaizenId: [this.kaizenAccountArray.data[i].kaizenId],
        costDirectionID: [{ value: this.kaizenAccountArray.data[i].costDirectionId, disabled: disableDropdown }, Validators.required],
        costTypeID: [{ value: this.kaizenAccountArray.data[i].costTypeId, disabled: disableDropdown }, Validators.required],
        gLAccountImpactAreaID: [{ value: this.kaizenAccountArray.data[i].glAccountImpactAreaId, disabled: disableDropdown }, Validators.required],
        detailedAccountId: [{ value: this.kaizenAccountArray.data[i].detailedAccountId, disabled: disableDropdown }, Validators.required],
        savingsMeasureID: [{ value: this.kaizenAccountArray.data[i].savingsMeasureId, disabled: disableDropdown }, Validators.required],
        operationRate: [this.kaizenAccountArray.data[i].operationRate],
        taktTime: [this.kaizenAccountArray.data[i].taktTime],
        currencyId: [this.kaizenAccountArray.data[i].currencyId],
        processReduction: [this.kaizenAccountArray.data[i].processReduction],
        TWTReduction: [this.kaizenAccountArray.data[i].twtReduction],
        costPerUnit: [this.kaizenAccountArray.data[i].costPerUnit],
        totalCostMon1: [0],
        totalCostMon2: [0],
        totalCostMon3: [0],
        totalCostMon4: [0],
        totalCostMon5: [0],
        totalCostMon6: [0],
        totalCostMon7: [0],
        totalCostMon8: [0],
        totalCostMon9: [0],
        totalCostMon10: [0],
        totalCostMon11: [0],
        totalCostMon0: [0],
        totalCost: this.formBuilder.array(this.totalCost),
        totalCost12Months: [0],
        kaizenMonthlySaving: this.formBuilder.array(this.kaizenMonthlySaving),
        processReductionMaster: [0],
        processReductionMon0: [0],
        processReductionMon1: [0],
        processReductionMon2: [0],
        processReductionMon3: [0],
        processReductionMon4: [0],
        processReductionMon5: [0],
        processReductionMon6: [0],
        processReductionMon7: [0],
        processReductionMon8: [0],
        processReductionMon9: [0],
        processReductionMon10: [0],
        processReductionMon11: [0],
        twtReductionMon0: [0],
        twtReductionMon1: [0],
        twtReductionMon2: [0],
        twtReductionMon3: [0],
        twtReductionMon4: [0],
        twtReductionMon5: [0],
        twtReductionMon6: [0],
        twtReductionMon7: [0],
        twtReductionMon8: [0],
        twtReductionMon9: [0],
        twtReductionMon10: [0],
        twtReductionMon11: [0],
        twtReductionMaster: [0],
        nextFYTotalSavings: [this.kaizenAccountArray.data[i].nextFYTotalSavings],
        averageCPUSavings: [this.kaizenAccountArray.data[i].averageCPUSavings],
        totalSavings: [this.kaizenAccountArray.data[i].totalSavings],
        totalVolume: [this.kaizenAccountArray.data[i].totalVolume],
      });
  }
  getAccountFormArray() { return this.fifthFormGroup.get('accountArray') as UntypedFormArray }
  getCostDirection(): void { firstValueFrom(this.CostDirectionService.getCostDirections()).then((data) => { this.costDirections = data?.data || [] ; this.costDirectionsLoaded = true; }) }
  //getCostType(): void { this.CostTypeService.getCostTypes().subwscribe(data => this.costTypes = data.data, error => console.log(error), () => this.costTypesLoaded = true); }
  getCostType(): void {
    this.CostTypeService.getCostTypes().subscribe({
      next: data => {
        this.costTypes = data.data;
        this.costTypesLoaded = true;
      },
      error: error => console.log(error)
    });
  }
  getAccounts(): void { firstValueFrom(this.AccountService.getAccounts(localStorage.getItem('ademail')!)).then((data) => { this.accounts = data?.data || [] ; this.accountsLoaded = true; }); }
  getDetailedAccounts(acId:number, i:number): void { 
    this.DetailedAccountService.getDetailedAccountByAcId(acId).subscribe(data => 
      {
        this.detailedAccounts = data.data;
        this.filteredDetailedAccounts = this.detailedAccounts;
        this.filteredDetailedAccountsArray[i] = this.filteredDetailedAccounts;
      }
      , error => console.log(error), () => this.detailedAccountsLoaded = true); }
  //getSavingsMeasures(): void { this.SavingMeasureService.getSavingsMeasures().subswcribe(data => this.savingsMeasure = data.data, error => console.log(error), () => this.savingsMeasureLoaded = true); }
  getSavingsMeasures(): void {
    this.SavingMeasureService.getSavingsMeasures().subscribe({
      next: data => {
        this.savingsMeasure = data.data;
        this.savingsMeasureLoaded = true;
      },
      error: error => console.log(error)
    });
  }
  getYearlyProductFacts(id: number, startDate: string, labourClass: string, getByModel: number, shopId: number, companyId: number, i: number) {
    firstValueFrom(this.yearlyProductService.getYearlyProductFacts(id, startDate, labourClass, getByModel, shopId, companyId)
      ).then((data) => {
        this.yearlyProductFacts = data?.data || [] ;
        this.yearlyProductFactsLoaded = true;
        this.yearlyProductFactsAcAry[i] = data?.data || [] ;
        this.calcTableTotal(i);
      });
  }
  calcTableTotal(i: number) {
    this.tableTotal[i] = 0;
    this.tableTotalVolume[i] = 0;
    this.tableCPUTotalSavings[i] = 0;
    this.tableTotalCapacity[i] = 0;
    this.tableTotalMonthlySavings[i] = 0;
    this.tableTotalMonthlySavingsNextFiscalYear[i] = 0;
    this.tableCPUTotalSavingsCPU[i] = 0;
    this.tableTotalCPUSavings[i] = 0;
    this.tableTotalTWT[i] = 0;
    this.tableTotalShifts[i] = 0;
    this.tableTotalMonthlySavingstwt[i] = 0;
    this.tableTotalCPUSavingstwt[i] = 0;
    let stdRate: number = 0;
    let flagFinEnd: boolean = false;
    let flagCurYear: boolean = false;
    let curyear:number = 0;
    let monthno: number = 0;
    let processReductionSavingsStarted: boolean = false;
    //processCumulativeMonthly is the extended monthly savings due to process reductions
    let processCumulativeMonthly: number = 0;
    //processCumulative is the running cumulative which is assigned to the Cumulative Savings row of the grid 
    let processCumulative: number = 0;
    //processTwtCumulativeMonthly is the extended monthly savings due to process reductions
    let processTwtCumulativeMonthly: number = 0;
    if (this.yearlyProductFactsAcAry[i] != null) 
    {
      for (let x = 0; x < 12; x++) 
      {
        stdRate = this.yearlyProductFactsAcAry[i][x].standardRate;
        this.tableTotal[i] += this.yearlyProductFactsAcAry[i][x].monthlySavings;
        this.tableTotalSavings[i] += (Number(this.yearlyProductFactsAcAry[i][x].modelVolume) * this.accountArray.getRawValue()[i].costPerUnit)
        this.tableTotalCapacity[i] += Number(this.yearlyProductFactsAcAry[i][x].modelVolume);
        this.tableTotalMonthlySavingsNextFiscalYear[i] += Number(stdRate * this.yearlyProductFactsAcAry[i][x].workingDays * this.yearlyProductFactsAcAry[i][x].numberOfShifts * this.accountArray.getRawValue()[i]['processReductionMon' + x] * this.yearlyProductFactsAcAry[i][x].workingHours) * x;
        this.tableTotalCPUSavings[i] += Number(stdRate * this.yearlyProductFactsAcAry[i][x].workingDays * this.yearlyProductFactsAcAry[i][x].numberOfShifts * this.accountArray.getRawValue()[i]['processReductionMon' + x] * this.yearlyProductFactsAcAry[i][x].workingHours) / Number(this.yearlyProductFactsAcAry[i][x].modelVolume);
        this.gridMonthlySavingsPR[i][x] = Number(stdRate * this.yearlyProductFactsAcAry[i][x].workingDays * this.yearlyProductFactsAcAry[i][x].numberOfShifts * this.accountArray.getRawValue()[i]['processReductionMon' + x] * this.yearlyProductFactsAcAry[i][x].workingHours);
        this.gridCPUSavingsPR[i][x] = Number(stdRate * this.yearlyProductFactsAcAry[i][x].workingDays * this.yearlyProductFactsAcAry[i][x].numberOfShifts * this.accountArray.getRawValue()[i]['processReductionMon' + x] * this.yearlyProductFactsAcAry[i][x].workingHours) / Number(this.yearlyProductFactsAcAry[i][x].modelVolume);
        this.tableTotalMonthlySavingstwt[i] += Number(stdRate * this.yearlyProductFactsAcAry[i][x].workingDays * this.yearlyProductFactsAcAry[i][x].numberOfShifts * this.accountArray.getRawValue()[i]['twtReductionMon' + x]);
        this.tableTotalCPUSavingstwt[i] += Number(stdRate * this.yearlyProductFactsAcAry[i][x].workingDays * this.yearlyProductFactsAcAry[i][x].numberOfShifts * this.accountArray.getRawValue()[i]['twtReductionMon' + x]) / Number(this.yearlyProductFactsAcAry[i][x].modelVolume);
        this.gridMonthlySavingsTWT[i][x] = Number(stdRate * this.yearlyProductFactsAcAry[i][x].workingDays * this.yearlyProductFactsAcAry[i][x].numberOfShifts * this.accountArray.getRawValue()[i]['twtReductionMon' + x]);
        this.gridCPUSavingsTWT[i][x] = Number(stdRate * this.yearlyProductFactsAcAry[i][x].workingDays * this.yearlyProductFactsAcAry[i][x].numberOfShifts * this.accountArray.getRawValue()[i]['twtReductionMon' + x]) / Number(this.yearlyProductFactsAcAry[i][x].modelVolume);
        this.gridTWTSavings[i][x] = Number(this.yearlyProductFactsAcAry[i][x].workingDays * this.yearlyProductFactsAcAry[i][x].numberOfShifts * this.accountArray.getRawValue()[i]['twtReductionMon' + x]);
        processCumulative += this.accountArray.getRawValue()[i]['processReductionMon' + x];
        processCumulativeMonthly += Number(stdRate * this.yearlyProductFactsAcAry[i][x].workingDays * this.yearlyProductFactsAcAry[i][x].numberOfShifts * this.yearlyProductFactsAcAry[i][x].workingHours * processCumulative);
        this.prCumulativeSavings[i][x] = processCumulativeMonthly;
        //if it is Process Reduction calculate the TWT savings 
        if (this.accountArray.getRawValue()[i]['savingsMeasureID'] == 2)
        {
            this.gridMonthlySavingsTWTPR[i][x] = Number(this.yearlyProductFactsAcAry[i][x].workingDays* this.yearlyProductFactsAcAry[i][x].numberOfShifts*this.accountArray.getRawValue()[i]['processReductionMon' + x]*this.yearlyProductFactsAcAry[i][x].workingHours);
            processTwtCumulativeMonthly += Number(this.yearlyProductFactsAcAry[i][x].workingDays * this.yearlyProductFactsAcAry[i][x].numberOfShifts * this.yearlyProductFactsAcAry[i][x].workingHours * processCumulative);
            this.prTWTCumulativeSavings[i][x] = processTwtCumulativeMonthly;
        }
        this.tableTotalTWT[i] += Number(this.accountArray.getRawValue()[i].twtReduction);
        this.tableTotalShifts[i] += Number(this.yearlyProductFactsAcAry[i][x].numberOfShifts);
        //Set flag is Process Reduction Savings have begun
        if (processReductionSavingsStarted == false && this.accountArray.getRawValue()[i]['processReductionMon' + x] > 0) {
          processReductionSavingsStarted = true;
        }
        this.kaizenMonthlySaving[x].costPerUnitSavings = this.gridCPUSavingsPR[i][x];
        //Add this months volume to the total is necessary and calculate the CPU 
        if (this.gridCPUSavingsPR[i][x] > 0
          || this.gridCPUSavingsTWT[i][x] > 0
          || processReductionSavingsStarted == true
          || this.accountArray.getRawValue()[i].costPerUnit > 0
        ) {
          this.tableTotalVolume[i] += Number(this.yearlyProductFactsAcAry[i][x].modelVolume);
          this.gridCPUSavingsPR[i][x] = (stdRate * this.yearlyProductFactsAcAry[i][x].workingDays * this.yearlyProductFactsAcAry[i][x].numberOfShifts * this.yearlyProductFactsAcAry[i][x].workingHours * processCumulative) / this.yearlyProductFactsAcAry[i][x].modelVolume;
          this.kaizenMonthlySaving[x].costPerUnitSavings = this.gridCPUSavingsPR[i][x];
        }
      }
      this.tableTotalMonthlySavings[i] = this.prCumulativeSavings[i][11];
      //Cost Per Unit
      if (this.accountArray.getRawValue()[i]['savingsMeasureID'] == 4) 
      {
        this.tableCPUTotalSavingsNextFiscalYear[i] = 0;
        this.tableCPUTotalSavingsCPU[i] = 0;
        this.tableTotalVolumeCurFisYear[i] = 0;
        this.tableTotalMonthlySavingsNextFiscalYear[i] = 0;
        this.tableTotalCapacity[i] = 0;
        this.tableTotalVolume[i] = 0;
        this.setFiscalImpDateMixCPU(i);
        this.tableCPUTotalSavings[i] = 0;
        var implementationMonthIndex = this.monthList.findIndex(x=> x.Value == Number(this.CreateKaizen.estimatedImplementationMonth));
        this.cPuProductFactsAcAry[i].forEach((monx: any) => 
        {          
          //If the current monthno is less than the index of the implementation month then it is next fiscal year, otherwise it is this fiscal year
          if(monthno < implementationMonthIndex)
          {
            this.tableCPUTotalSavingsNextFiscalYear[i] += (Number(this.cPuProductFactsAcAry[i][monthno].modelVolume) * this.accountArray.getRawValue()[i].costPerUnit);
          }
          else
          {
            this.tableCPUTotalSavings[i] += (Number(this.cPuProductFactsAcAry[i][monthno].modelVolume) * this.accountArray.getRawValue()[i].costPerUnit);
            this.tableTotalVolumeCurFisYear[i] += Number(this.cPuProductFactsAcAry[i][monthno].modelVolume);
          }
          monthno++;
        });

        this.tableTotalCapacity[i] = this.tableTotalVolumeCurFisYear[i];
        this.tableTotalVolume[i] = this.tableTotalVolumeCurFisYear[i];
        this.tableCPUTotalSavingsCPU[i] = this.tableCPUTotalSavings[i] / this.tableTotalVolumeCurFisYear[i];
        this.tableTotalMonthlySavingsNextFiscalYear[i] = this.tableCPUTotalSavingsNextFiscalYear[i];
        this.tableTotalMonthlySavings[i] = this.tableCPUTotalSavings[i];
      }
      //Total Cost
      if (this.accountArray.getRawValue()[i]['savingsMeasureID'] == 5) 
      {
          //Get the index of the first month with a non zero cost.  This will be the number of months carry over into next fiscal year
          //Get the last value of the total cost array this is the amount carried over into next year
          //Multiply the number of month times the last total cost to get next fiscal year total saving
          let indexOfFisrtMonthWithCost:number = this.tableTotalCost[i].findIndex(v=>v>0);
          let lastMonthTotalCost = this.tableTotalCost[i][11];
          this.tableTotalCostTotalSavingsNextFiscalYear[i] = indexOfFisrtMonthWithCost*lastMonthTotalCost;
          this.tableTotalMonthlySavingsNextFiscalYear[i] = this.tableTotalCostTotalSavingsNextFiscalYear[i];
      }
      //setting the totals in the accountArray so that they get passed to API when KaizenAccounts array is set equal to accountArray.  Value needs to be
      // of type any for the patchValue
      let NextFYTotalSavings: number = this.tableTotalMonthlySavingsNextFiscalYear[i];
      ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('nextFYTotalSavings')?.patchValue(NextFYTotalSavings);
      let TotalVolume: number = this.tableTotalVolume[i];
      ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('totalVolume')?.patchValue(TotalVolume);
      let AverageCPUSavings: any = 0;
      if (this.showTotalWorkingTimeReductionTable[i] == true) {
        if (!isNaN(this.tableTotalVolume[i]) && this.tableTotalVolume[i] != 0) {
          AverageCPUSavings = (this.tableTotalMonthlySavingstwt[i] / this.tableTotalVolume[i]).toFixed(2);
        }
        ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('averageCPUSavings')?.patchValue(AverageCPUSavings);
        let TotalSavings: any = this.tableTotalMonthlySavingstwt[i];
        ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('totalSavings')?.patchValue(TotalSavings);
      }
      else if (this.showTotalCostTable[i] == true) {
        ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('averageCPUSavings')?.patchValue(AverageCPUSavings);
        let TotalSavings: any = this.tableTotalMonthlySavings[i];
        ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('totalSavings')?.patchValue(TotalSavings);
      }
      else {
        if (!isNaN(this.tableTotalVolume[i]) && this.tableTotalVolume[i] != 0) {
          AverageCPUSavings = (this.tableTotalMonthlySavings[i] / this.tableTotalVolume[i]).toFixed(2);
        }
        ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('averageCPUSavings')?.patchValue(AverageCPUSavings);
        let TotalSavings: any = this.tableTotalMonthlySavings[i];
        ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('totalSavings')?.patchValue(TotalSavings);
      }
    }
  }
  onAccountCurrencyChange(e: any, accountNumber: number){
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(accountNumber) as UntypedFormGroup).get('currencyId')?.patchValue(e.target.value);
    this.fifthFormValid = true;
    this.emitAccounts();
  }
  oncostPerUnitChangeEvent(e: any, accountNumber: number) {
    this.totalCostPerUnit = e.target.value;
    this.calcTableTotal(accountNumber);
    if (this.tabletotalCostPerUnit[accountNumber] != e.target.value) {
      this.reApprovalReq = true;
    }
    this.tabletotalCostPerUnit[accountNumber] = e.target.value;    
    for(var controlMon = 0 ; controlMon < 12; controlMon++)
    {
      if (this.kaizenAccountArray != null 
          && this.kaizenMonthlySavingsList.data.length > 0 
          && this.kaizenAccountArray.data !=null 
          && this.kaizenAccountArray.data[accountNumber]) 
      { 
        this.monthlySavingsPrAry = this.kaizenMonthlySavingsList.data.filter(x => x.kaizenAccountId == this.kaizenAccountArray.data[accountNumber].kaizenAccountId);
        if (this.monthlySavingsPrAry[controlMon].kaizenMonthlySavingId != 0) 
        {        
          const kms: KaizenMonthlySaving = {
            kaizenMonthlySavingId: this.monthlySavingsPrAry[controlMon].kaizenMonthlySavingId,
            CalendarMonthID: this.monthlySavingsPrAry[controlMon].calendarMonthID,
            WorkingDays: this.monthlySavingsPrAry[controlMon].workingDays,
            WorkingHours: this.yearlyProductFactsAcAry[accountNumber][controlMon].workingHours,
            NumberOfShifts: this.monthlySavingsPrAry[controlMon].numberOfShifts,
            StandardRate: this.monthlySavingsPrAry[controlMon].standardRate,
            Capacity: this.monthlySavingsPrAry[controlMon].capacity,
            MonthHead: this.monthlySavingsPrAry[controlMon].monthHead,
            MonthlySavings: this.yearlyProductFactsAcAry[accountNumber][controlMon].modelVolume * e.target.value * this.fiscalImpDateMixCPU[accountNumber][controlMon],
            costPerUnitSavings: 0,
            processReduction: 0,
            twtReduction: 0
          }
          this.kaizenMonthlySaving[controlMon] = kms;
        }
        else 
        {
          const kms: KaizenMonthlySaving = {
            kaizenMonthlySavingId: 0,
            CalendarMonthID: this.yearlyProductFactsAcAry[accountNumber][controlMon].calendarMonthID,
            WorkingDays: this.yearlyProductFactsAcAry[accountNumber][controlMon].workingDays,
            WorkingHours: this.yearlyProductFactsAcAry[accountNumber][controlMon].workingHours,
            NumberOfShifts: this.yearlyProductFactsAcAry[accountNumber][controlMon].numberOfShifts,
            StandardRate: this.yearlyProductFactsAcAry[accountNumber][controlMon].standardRate,
            Capacity: this.yearlyProductFactsAcAry[accountNumber][controlMon].modelVolume,
            MonthHead: this.yearlyProductFactsAcAry[accountNumber][controlMon].month,
            MonthlySavings: this.yearlyProductFactsAcAry[accountNumber][controlMon].modelVolume * e.target.value * this.fiscalImpDateMixCPU[accountNumber][controlMon],
            costPerUnitSavings: 0,
            processReduction: 0,
            twtReduction: 0
          }
          this.kaizenMonthlySaving[controlMon] = kms;
        }
      }
      else 
      {
        const kms: KaizenMonthlySaving = {
          kaizenMonthlySavingId: 0,
          CalendarMonthID: this.yearlyProductFactsAcAry[accountNumber][controlMon].calendarMonthID,
          WorkingDays: this.yearlyProductFactsAcAry[accountNumber][controlMon].workingDays,
          WorkingHours: this.yearlyProductFactsAcAry[accountNumber][controlMon].workingHours,
          NumberOfShifts: this.yearlyProductFactsAcAry[accountNumber][controlMon].numberOfShifts,
          StandardRate: this.yearlyProductFactsAcAry[accountNumber][controlMon].standardRate,
          Capacity: this.yearlyProductFactsAcAry[accountNumber][controlMon].modelVolume,
          MonthHead: this.yearlyProductFactsAcAry[accountNumber][controlMon].month,
          MonthlySavings: this.yearlyProductFactsAcAry[accountNumber][controlMon].modelVolume * e.target.value * this.fiscalImpDateMixCPU[accountNumber][controlMon],
          costPerUnitSavings: 0,
          processReduction: 0,
          twtReduction: 0
        }
        this.kaizenMonthlySaving[controlMon] = kms;
      }
    }

    this.fifthFormValid = true;
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(accountNumber) as UntypedFormGroup).get('kaizenMonthlySaving')?.patchValue(this.kaizenMonthlySaving);
    
    this.netSavingsTableCalculationsNewAc();
    this.emitAccounts();
  }
  onProcessReductionChangeEvent(e: any, i: number) {
    const controlName = e.target.getAttribute('formControlName');
    const controlMon = controlName.replace('processReductionMon', '');
    this.processReduction = e.target.value == '' ? 0 : e.target.value;
    if (this.tableProcessReduction[i][controlMon] != this.processReduction) {
      this.reApprovalReq = true;
    }
    this.tableProcessReduction[i][controlMon] = this.processReduction;
    this.netSavingsTableCalculationsNewAc();
    if (this.kaizenAccountArray != undefined) {
      if (this.kaizenAccountArray.data == undefined || this.kaizenAccountArray.data[i] == undefined) {
        this.populateMonthlySavings(this.processReduction, 0, controlMon, i, true);
      }
      else {
        if(this.reloadKaizenId != 0){
          this.populateMonthlySavings(this.processReduction, 0, controlMon, i, true);
        }
        else{
        this.populateMonthlySavings(this.processReduction, 0, controlMon, i, false);
        }
      }
    }
    else {
      this.populateMonthlySavings(this.processReduction, 0, controlMon, i, false);
    }
    this.calcTableTotal(i);
    this.netSavingsTableCalculationsNewAc();
    this.fifthFormValid = true;
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('kaizenMonthlySaving')?.patchValue(this.kaizenMonthlySaving);
    this.emitAccounts();
  }
  ontwtReductionChangeEvent(e: any, i: number) {
    this.twtReduction = e.target.value == '' ? 0 : e.target.value;
    console.log('this.twtReduction',this.twtReduction);
    const controlName = e.target.getAttribute('formControlName');
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get(controlName)?.patchValue(this.twtReduction);
    const controlMon = controlName.replace('twtReductionMon', '');
    if (this.tableTwtReduction[i][controlMon] != this.twtReduction) {
      this.reApprovalReq = true;
    }
    this.tableTwtReduction[i][controlMon] = this.twtReduction;
    this.calcTableTotal(i);
    this.netSavingsTableCalculationsNewAc();
    if (this.kaizenAccountArray != undefined) {
      if (this.kaizenAccountArray.data == undefined || this.kaizenAccountArray.data[i] == undefined) {
        this.populateMonthlySavings(0, this.twtReduction, controlMon, i, true);
      }
      else {
        this.populateMonthlySavings(0, this.twtReduction, controlMon, i, false);
      }
    }
    else {
      this.populateMonthlySavings(0, this.twtReduction, controlMon, i, false);
    }
    this.fifthFormValid = true;
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('kaizenMonthlySaving')?.patchValue(this.kaizenMonthlySaving);
    this.emitAccounts();
  }
  populateMonthlySavings(prReduction: number, twtReduction: number, controlMon: number, accountNumber: number, newac: boolean) {
    let reduc: number = 0;  
    let workingHours: number = 0;
    if (prReduction != 0) {
      reduc = prReduction;
    }
    else {
      reduc = twtReduction;
    }
    if (this.kaizenAccountArray != null && this.kaizenMonthlySavingsList.data.length >0) 
    {
      
      if (newac == false && this.isRecalc == false) 
      {
        this.monthlySavingsPrAry = this.kaizenMonthlySavingsList.data.filter(x => x.kaizenAccountId == this.kaizenAccountArray.data[accountNumber].kaizenAccountId);
        this.kaizenMonthlySaving = this.monthlySavingsPrAry;
        //since records may be saved with no volumes, we cannot just divide by the volume as this causes problems.  In these cases we divide by
        //1 instead and that gives a zero for cost per unit in stead of NaN
        var volume = this.monthlySavingsPrAry[controlMon].capacity;
        if (this.monthlySavingsPrAry[controlMon].capacity == 0) 
        {
          volume = 1;
        }        
        workingHours = prReduction != 0 ? this.monthlySavingsPrAry[controlMon].workingHours : 1;        
        const kms: KaizenMonthlySaving = 
        {
          kaizenMonthlySavingId: this.monthlySavingsPrAry[controlMon].kaizenMonthlySavingId,
          CalendarMonthID: this.monthlySavingsPrAry[controlMon].calendarMonthID,
          WorkingDays: this.monthlySavingsPrAry[controlMon].workingDays,
          WorkingHours: this.monthlySavingsPrAry[controlMon].WorkingHours,
          NumberOfShifts: this.monthlySavingsPrAry[controlMon].numberOfShifts,
          StandardRate: this.monthlySavingsPrAry[controlMon].standardRate,
          Capacity: this.monthlySavingsPrAry[controlMon].capacity,
          MonthHead: this.monthlySavingsPrAry[controlMon].monthHead,
          MonthlySavings: this.monthlySavingsPrAry[controlMon].standardRate * this.monthlySavingsPrAry[controlMon].workingDays * this.monthlySavingsPrAry[controlMon].numberOfShifts * reduc * workingHours,
          costPerUnitSavings: Math.round(((this.monthlySavingsPrAry[controlMon].standardRate * this.monthlySavingsPrAry[controlMon].workingHours * this.monthlySavingsPrAry[controlMon].numberOfShifts * reduc * this.monthlySavingsPrAry[controlMon].workingHours) / volume)),
          processReduction: prReduction,
          twtReduction: twtReduction
        }
        this.kaizenMonthlySaving[controlMon] = kms;
        //we need to write the new value back to the kaizenMonthlySavingsList, so retreive the record and update the prReduction and twtReduction
        let updatedKaizenMonthlySavingListItem = this.kaizenMonthlySavingsList.data.find(x => x.kaizenMonthlySavingId == kms.kaizenMonthlySavingId);
        if (updatedKaizenMonthlySavingListItem) {
          updatedKaizenMonthlySavingListItem.processReduction = prReduction;
          updatedKaizenMonthlySavingListItem.twtReduction = twtReduction;
          updatedKaizenMonthlySavingListItem.monthlySavings = kms.MonthlySavings;
        }
      }
      else 
      {        
        workingHours = prReduction != 0 ? this.yearlyProductFactsAcAry[accountNumber][controlMon].workingHours : 1;        
        let kmsId: number = 0
        if(this.isRecalc == true)
        {
          this.monthlySavingsPrAry = this.kaizenMonthlySavingsList.data.filter(x => x.kaizenAccountId == this.kaizenAccountArray.data[accountNumber].kaizenAccountId);
          this.kaizenMonthlySaving = this.monthlySavingsPrAry;        
          kmsId = this.monthlySavingsPrAry[controlMon].kaizenMonthlySavingId
        }
        const kms: KaizenMonthlySaving = 
        {
          kaizenMonthlySavingId:kmsId,
          CalendarMonthID: this.yearlyProductFactsAcAry[accountNumber][controlMon].calendarMonthID,
          WorkingDays: this.yearlyProductFactsAcAry[accountNumber][controlMon].workingDays,
          WorkingHours: this.yearlyProductFactsAcAry[accountNumber][controlMon].workingHours,
          NumberOfShifts: this.yearlyProductFactsAcAry[accountNumber][controlMon].numberOfShifts,
          StandardRate: this.yearlyProductFactsAcAry[accountNumber][controlMon].standardRate,
          Capacity: this.yearlyProductFactsAcAry[accountNumber][controlMon].modelVolume,
          MonthHead: this.yearlyProductFactsAcAry[accountNumber][controlMon].month,
          MonthlySavings: this.yearlyProductFactsAcAry[accountNumber][controlMon].standardRate * this.yearlyProductFactsAcAry[accountNumber][controlMon].workingDays * this.yearlyProductFactsAcAry[accountNumber][controlMon].numberOfShifts * reduc * workingHours,
          costPerUnitSavings: (this.yearlyProductFactsAcAry[accountNumber][controlMon].standardRate * this.yearlyProductFactsAcAry[accountNumber][controlMon].workingDays * this.yearlyProductFactsAcAry[accountNumber][controlMon].numberOfShifts * reduc * this.yearlyProductFactsAcAry[accountNumber][controlMon].workingHours) / this.yearlyProductFactsAcAry[accountNumber][controlMon].modelVolume,
          processReduction: prReduction,
          twtReduction: twtReduction
        }
        this.kaizenMonthlySaving[controlMon] = kms;
      }
      //  ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(0) as UntypedFormGroup).get('kaizenMonthlySaving')?.patchValue(this.kaizenMonthlySaving);
      //  this.emitAccounts();
    }
    else 
    {
      workingHours = prReduction != 0 ? this.yearlyProductFactsAcAry[accountNumber][controlMon].workingHours : 1;
      const kms: KaizenMonthlySaving = {
        kaizenMonthlySavingId: 0,
        CalendarMonthID: this.yearlyProductFactsAcAry[accountNumber][controlMon].calendarMonthID,
        WorkingDays: this.yearlyProductFactsAcAry[accountNumber][controlMon].workingDays,
        WorkingHours: this.yearlyProductFactsAcAry[accountNumber][controlMon].workingHours,
        NumberOfShifts: this.yearlyProductFactsAcAry[accountNumber][controlMon].numberOfShifts,
        StandardRate: this.yearlyProductFactsAcAry[accountNumber][controlMon].standardRate,
        Capacity: this.yearlyProductFactsAcAry[accountNumber][controlMon].modelVolume,
        MonthHead: this.yearlyProductFactsAcAry[accountNumber][controlMon].month,
        MonthlySavings: this.yearlyProductFactsAcAry[accountNumber][controlMon].standardRate * this.yearlyProductFactsAcAry[accountNumber][controlMon].workingDays * this.yearlyProductFactsAcAry[accountNumber][controlMon].numberOfShifts * reduc * workingHours,
        costPerUnitSavings: (this.yearlyProductFactsAcAry[accountNumber][controlMon].standardRate * this.yearlyProductFactsAcAry[accountNumber][controlMon].workingDays * this.yearlyProductFactsAcAry[accountNumber][controlMon].numberOfShifts * reduc * this.yearlyProductFactsAcAry[accountNumber][controlMon].workingHours) / this.yearlyProductFactsAcAry[accountNumber][controlMon].modelVolume,
        processReduction: prReduction,
        twtReduction: twtReduction
      }
      this.kaizenMonthlySaving[controlMon] = kms;
    }
  }  
  populateMonthlySavingsTCpu(totalCost: number, cPU: number, controlMon: number, accountNumber: number, newac: boolean) {
    let reduc: number = 0;
    if (totalCost != 0) {
      reduc = totalCost;
    }
    else {
      reduc = cPU;
    }
    // if (this.kaizenAccountArray != undefined && this.kaizenAccountArray.data[accountNumber] != undefined) {
    if (this.kaizenAccountArray != null && this.kaizenAccountArray.data != null && this.kaizenMonthlySavingsList.data.length > 0) 
    {
      if (newac == false && this.kaizenAccountArray.data.length > accountNumber) 
      {
        this.monthlySavingsPrAry = this.kaizenMonthlySavingsList.data.filter(x => x.kaizenAccountId == this.kaizenAccountArray.data[accountNumber].kaizenAccountId);
        const kms: KaizenMonthlySaving = 
        {
          kaizenMonthlySavingId: this.monthlySavingsPrAry[controlMon].kaizenMonthlySavingId,
          CalendarMonthID: this.monthlySavingsPrAry[controlMon].calendarMonthID,
          WorkingDays: this.monthlySavingsPrAry[controlMon].workingDays,
          WorkingHours: this.monthlySavingsPrAry[controlMon].workingHours,
          NumberOfShifts: this.monthlySavingsPrAry[controlMon].numberOfShifts,
          StandardRate: this.monthlySavingsPrAry[controlMon].standardRate,
          Capacity: this.monthlySavingsPrAry[controlMon].capacity,
          MonthHead: this.monthlySavingsPrAry[controlMon].monthHead,
          MonthlySavings: reduc,
          costPerUnitSavings: 0,
          processReduction: 0,
          twtReduction: 0
        }
        this.kaizenMonthlySaving[controlMon] = kms;
      }
      else 
      {
        const kms: KaizenMonthlySaving = {
          kaizenMonthlySavingId: 0,
          CalendarMonthID: this.yearlyProductFactsAcAry[accountNumber][controlMon].calendarMonthID,
          WorkingDays: this.yearlyProductFactsAcAry[accountNumber][controlMon].workingDays,
          WorkingHours: this.yearlyProductFactsAcAry[accountNumber][controlMon].workingHours,
          NumberOfShifts: this.yearlyProductFactsAcAry[accountNumber][controlMon].numberOfShifts,
          StandardRate: this.yearlyProductFactsAcAry[accountNumber][controlMon].standardRate,
          Capacity: this.yearlyProductFactsAcAry[accountNumber][controlMon].modelVolume,
          MonthHead: this.yearlyProductFactsAcAry[accountNumber][controlMon].month,
          MonthlySavings: reduc,
          costPerUnitSavings: 0,
          processReduction: 0,
          twtReduction: 0
        }
        this.kaizenMonthlySaving[controlMon] = kms;
      }
    }
    else {
      const kms: KaizenMonthlySaving = {
        kaizenMonthlySavingId: 0,
        CalendarMonthID: this.yearlyProductFactsAcAry[accountNumber][controlMon].calendarMonthID,
        WorkingDays: this.yearlyProductFactsAcAry[accountNumber][controlMon].workingDays,
        WorkingHours: this.yearlyProductFactsAcAry[accountNumber][controlMon].workingHours,
        NumberOfShifts: this.yearlyProductFactsAcAry[accountNumber][controlMon].numberOfShifts,
        StandardRate: this.yearlyProductFactsAcAry[accountNumber][controlMon].standardRate,
        Capacity: this.yearlyProductFactsAcAry[accountNumber][controlMon].modelVolume,
        MonthHead: this.yearlyProductFactsAcAry[accountNumber][controlMon].month,
        MonthlySavings: reduc,
        costPerUnitSavings: 0,
        processReduction: 0,
        twtReduction: 0
      }
      this.kaizenMonthlySaving[controlMon] = kms;

    }   
    this.accountAdded = false;
  }
  getCostDirectionForEdit(): void {
    firstValueFrom(this.CostDirectionService.getCostDirections()).then((data) => {
      this.costDirections = data?.data || [] ;
      // this.fifthFormGroup.controls['costDirectionID'].setValue(this.CreateKaizen.costDirectionID);
      //  console.log("Promise resolved with: " + JSON.stringify(data));
    }, (error) => {
      // console.log("Promise PendingRevision with " + JSON.stringify(error));
    })
  };
  getCostTypeForEdit(costDirID: number, accNo: number): void {
    firstValueFrom(this.CostTypeService.getCostTypes()).then((data) => {
      this.costTypes = data?.data || [] ;
      this.filteredCostTypeArray[accNo] = this.costTypes.filter(x => x.costDirectionID == costDirID);
      //  this.fifthFormGroup.controls['costTypeID'].setValue(this.CreateKaizen.costTypeID);
      //  console.log("Promise resolved with: " + JSON.stringify(data));
    }, (error) => {
      //   console.log("Promise PendingRevision with " + JSON.stringify(error));
    })
  };
  getAccountForEdit(costtypeid: number, accno: number): void {
    let emailId = localStorage.getItem('ademail')!;
    firstValueFrom(this.AccountService.getAccounts(emailId)).then((data) => {
      this.accounts = data?.data || [] ;
      var value = this.accounts.find(x => x.glAccountImpactAreaId == costtypeid)?.name;
      this.selectedLabourClass = '';
      if (value == undefined) { }
      else if (value == "A Labour")
        this.selectedLabourClass = "A";
      else if (value == "B1 Labour")
        this.selectedLabourClass = "B1";
      else if (value == "B2 Labour")
        this.selectedLabourClass = "B2";
      else if (value == "C1 Labour")
        this.selectedLabourClass = "C1";
      else if (value == "C2 Labour")
        this.selectedLabourClass = "C2";
      else if (value == "D Labour")
        this.selectedLabourClass = "D"
      else if (value == "E Labour")
        this.selectedLabourClass = "E"
      //  console.log("Promise resolved with: " + JSON.stringify(data));
    }, (error) => {
      //   console.log("Promise PendingRevision with " + JSON.stringify(error));
    })
  };
  getDetailedAccountsForEdit(accID: number, accNo: number): void {
    this.getDetailedAccounts(accID,accNo);
  };
  getSavingsMeasuresForEdit(accID: number, accNo: number): void {
    //  console.log('accountid ' + accID + ' accou no ' + accNo);
    firstValueFrom(this.SavingMeasureService.getSavingsMeasures()).then((data) => {
      this.savingsMeasure = data?.data || [];
      if (accID == 2
        || accID == 3
        || accID == 26
        || accID == 27) {
        this.filteredSavingNMeasuresArray[accNo] = this.savingsMeasure.filter(x => x.savingsMeasureName == 'Process Reduction' || x.savingsMeasureName == 'Total Working Time Reduction')
      } else {
        this.filteredSavingNMeasuresArray[accNo] = this.savingsMeasure.filter(x => x.savingsMeasureName == 'Cost Per Unit' || x.savingsMeasureName == 'Total Cost')
      }
      var date = this.CreateKaizen.estimatedImplementationMonth + '-' + this.CreateKaizen.estimatedImplementationDay + '-' + this.CreateKaizen.estimatedImplementationYear
      //  console.log("Promise resolved with: " + JSON.stringify(data));
    },
      (error) => {
        //  console.log("Promise PendingRevision with " + JSON.stringify(error));
      })
  };
  hideFactsTable(i: number) {
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('costPerUnit')?.patchValue(0);
    for (var x = 0; x <= 11; x++) {
      const newstr = 'totalCostMon' + (x).toString();
      const newstrPR = 'processReductionMon' + (x).toString();
      const newstrTWT = 'TWTReductionMon' + (x).toString();
      ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get(newstr)?.patchValue(0);
      ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get(newstrPR)?.patchValue(0);
      ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get(newstrTWT)?.patchValue(0);
    }
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('totalCost12Months')?.patchValue(0);
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('operationRate')?.patchValue(false);
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('taktTime')?.patchValue(false);
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('currencyId')?.patchValue(1);
    this.showProcessReductionTable[i] = false;
    this.showTotalWorkingTimeReductionTable[i] = false;
    this.showCostPerUnitTable[i] = false;
    this.showTotalCostTable[i] = false;
  }
  async changeSavingsMeasure(e: any, i: number) {
    this.showNoDataErrMsg = false;
    let savingsmeasureid_ = e.target.options[e.target.options.selectedIndex].value;
    this.showTotalCostTable[i] = false;
    this.showCostPerUnitTable[i] = false;
    this.showProcessReductionTable[i] = false;
    this.showTotalWorkingTimeReductionTable[i] = false;
    this.tabletotalCostPerUnit[i] = 0;
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('costPerUnit')?.patchValue(0);
    //If NAMC is TMMC and savings measure is cost per unit or total cost default currency to CAD
    if(this.CreateKaizen.companyID == 1 && (savingsmeasureid_  == 4 || savingsmeasureid_ == 5))
    {
      ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('currencyId')?.patchValue(2);
    }
    var accountIndex = (this.accountArray.getRawValue()[i].gLAccountImpactAreaID);
    var accountType = this.accounts.filter(x => x.glAccountImpactAreaId == accountIndex)[0].name;
    this.labourcls[i] = (accountType.includes('Labour')) ? accountType.substring(0, accountType.length - 7) : "";
    let id: number = 0;
    if (this.CreateKaizen.kaizenImpactingModelID == 1) { id = this.CreateKaizen.companyID }
    else if (this.CreateKaizen.kaizenImpactingModelID == 2) { id = this.CreateKaizen.lineID }
    else if (this.CreateKaizen.kaizenImpactingModelID == 3) { id = this.CreateKaizen.shopID }
    else if (this.CreateKaizen.kaizenImpactingModelID == 4) { id = this.CreateKaizen.vehicleModelID }
    await firstValueFrom(this.yearlyProductService.getYearlyProductFacts(id, this.selectedDate, this.labourcls[i], this.CreateKaizen.kaizenImpactingModelID, this.CreateKaizen.shopID, this.CreateKaizen.companyID)
      ).then((data) => {
        if (data?.data.length == 0) {
          this.showNoDataErrMsg = true;
        }
        else {
          this.yearlyProductFacts = data?.data || [];
          this.yearlyProductFactsAcAry[i] = data?.data || [];
          this.cPuProductFactsAcAry[i] = data?.data || [];
          this.completeSavingsMeasureChange(i, savingsmeasureid_);
          this.emitAccounts();
        }
      })
      .catch(alert);
  }
  completeSavingsMeasureChange(accountNumber: number, savingsMeasureID: number) {
    this.calcTableTotal(accountNumber);
    
    for (var x = 0; x <= 11; x++) {
      this.tableProcessReduction[accountNumber][x] = 0;
      this.tableTwtReduction[accountNumber][x] = 0;
      const newstr = 'totalCostMon' + (x).toString();
      const newstrPR = 'processReductionMon' + (x).toString();
      const newstrtwt = 'twtReductionMon' + (x).toString();
      ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(accountNumber) as UntypedFormGroup).get(newstr)?.patchValue(0);
      ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(accountNumber) as UntypedFormGroup).get(newstrPR)?.patchValue(0);
      ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(accountNumber) as UntypedFormGroup).get(newstrtwt)?.patchValue(0);
      this.populateMonthlySavings(0, 0, x, accountNumber, true);
    }
    this.accountAdded = false;
    if (savingsMeasureID == 2) { // Process Reduction 
      this.showProcessReductionTable[accountNumber] = true;
    }
    else if (savingsMeasureID == 3) { // Total Working Time Reduction 
      this.showTotalWorkingTimeReductionTable[accountNumber] = true;
    }
    else if (savingsMeasureID == 4) { // Cost Per Unit 
      this.showCostPerUnitTable[accountNumber] = true;
      this.setFiscalImpDateMixCPU(accountNumber);
    }
    else if (savingsMeasureID == 5) { // Total Cost
      this.showTotalCostTable[accountNumber] = true;
    }
    this.yearlyProductFactsLoaded = true;
    this.reApprovalReq = true;
    this.btnSaveforLaterMultiAc = false;
    this.emitAccounts();
  }

  changeCostType(e: any, i: number) {
    this.hideFactsTable(i);
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('gLAccountImpactAreaID')?.patchValue(null);
    this.getAccounts();
    this.filteredSavingNMeasuresArray[i] = null;
    this.filteredSavingNMeasuresArraytmp[i] = null;
    this.filteredDetailedAccountsArray[i] = null;
    this.emitAccounts();
  }
  changeDirection(e: any, i: number) {
    //We no longer filter the cost type on the cost direction, but to avoid data issue we leave CostDirectionID on Cost Type and load
    //the drop down with all cost types.  The less than 3 is to avoid duplicate options in drop down
    this.filteredCostTypes = this.costTypes.filter(x => x.costDirectionID < 3); 
    this.hideFactsTable(i);
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('costTypeID')?.patchValue(null);
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('gLAccountImpactAreaID')?.patchValue(null);
    this.filteredCostTypeArray[i] = this.filteredCostTypes;
    this.getAccounts();
    this.filteredSavingNMeasuresArray[i] = null;
    this.filteredSavingNMeasuresArraytmp[i] = null;
    this.filteredDetailedAccountsArray[i] = null;
    this.emitAccounts();
  }
  changeCompletionMonth(e: any) {
    this.days.length = 0;
    var year = this.fifthFormGroup.value.completionYear;
    var numberOfDaysinMonth: number = 31;
    var selectedMonth = e.target.options[e.target.options.selectedIndex].text;
    if (selectedMonth == 'Apr' || selectedMonth == 'Jun' || selectedMonth == 'Sep' || selectedMonth == 'Nov') {
      numberOfDaysinMonth = 30;
    }
    else if (selectedMonth == 'Feb') {
      if ((year % 4 == 0) && (0 != year % 100) || (0 == year % 400)) {
        numberOfDaysinMonth = 29;
      } else {
        numberOfDaysinMonth = 28;
      }
    }
    for (var x = 1; x <= numberOfDaysinMonth; x++) {
      this.days.push({ Id: x.toString(), Name: x.toString() });
    }
  }
  public isNullorUndefinedOrEmpty(e: any) {
    return e == undefined || e == null || e.length < 12;
  }
  public updatetotalcostmonths() {
    this.sumtotal = 0;
    for (var x = 0; x <= 11; x++) {
      const newstr = 'totalCostMon' + (x).toString();
      this.totalCost[x] = 0;
      this.totalCost[x] = this.fifthFormGroup.controls[newstr].value;
      this.sumtotal += Number(this.fifthFormGroup.controls[newstr].value);
    }
  }
  onTotalCostMonthChange(e: any, i: number) {
    const controlName = e.target.getAttribute('formControlName');
    const controlMon = controlName.replace('totalCostMon', '');
    this.reApprovalReq = true;
    // var newAccount = true;
    // if(this.KaizenMonthlySavingAccountsAry[i][controlMon].kaizenMonthlySavingId != 0)
    // {
    //     newAccount = false;
    // }
    this.tableTotalCost[i][controlMon] = this.returnNumberOrzero(e.target.value);
    this.totalCost[controlMon] = this.returnNumberOrzero(e.target.value);
    this.totalCostCalculated = 0;
    this.tableTotalCost[i].forEach(element => { this.totalCostCalculated += Number(element) });
    this.tableTotalCostTotalSavings[i] = this.totalCostCalculated;
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('totalCost12Months')?.patchValue(this.totalCostCalculated);
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('totalSavings')?.patchValue(this.totalCostCalculated);
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('totalCost')?.patchValue(this.tableTotalCost[i]);
    this.populateMonthlySavingsTCpu(e.target.value, 0, controlMon,i, false);
    this.netSavingsTableCalculationsNewAc();
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('kaizenMonthlySaving')?.patchValue(this.kaizenMonthlySaving);
    this.fifthFormValid = true;
    this.emitAccounts();

  }
  changeAccountImpacted(e: any, i: number) {
    var selectedAccount: string = e.target.options[e.target.options.selectedIndex].text;
    this.selectedLabourClass = ""
    this.hideFactsTable(i);
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('savingsMeasureID')?.patchValue(null);
    if (selectedAccount == "A Labour"
      || selectedAccount == "B1 Labour"
      || selectedAccount == "B2 Labour"
      || selectedAccount == "C1 Labour"
      || selectedAccount == "C2 Labour"
    ) {
      this.selectedLabourClass = selectedAccount.substring(0, selectedAccount.length - 7);
      this.filteredSavingNMeasures = this.savingsMeasure.filter(x => x.savingsMeasureName == 'Process Reduction' || x.savingsMeasureName == 'Total Working Time Reduction')
      this.filteredSavingNMeasuresArraytmp[i] = this.filteredSavingNMeasures;
    } else {
      this.filteredSavingNMeasures = this.savingsMeasure.filter(x => x.savingsMeasureName == 'Cost Per Unit' || x.savingsMeasureName == 'Total Cost')
      this.filteredSavingNMeasuresArraytmp[i] = this.filteredSavingNMeasures;
    }
    this.getDetailedAccounts(e.target.value, i);
    this.filteredSavingNMeasuresArray[i] = null;
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('detailedAccountId')?.patchValue(null);
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(i) as UntypedFormGroup).get('savingsMeasureID')?.patchValue(null);
    this.emitAccounts();
  }
  changeDetailedAccount(e: any, i: number) {
    this.filteredSavingNMeasuresArray[i] = this.filteredSavingNMeasuresArraytmp[i];
  }
  getFiscalYear(impDate: Date) {
    const mon: number = impDate.getMonth() + 1;
    const yr: number = impDate.getFullYear();
    const fiscYearStart = mon <= 3 ? yr - 1 : yr;
    this.dateHeader = [];
    this.monthList.forEach((mont) => {
      this.dateHeader.push(mont.Text + '-' + (mont.Value <= 3 ? ((fiscYearStart + 1).toString()).substring(2, 4) : ((fiscYearStart).toString()).substring(2, 4)));
    });
    this.fiscalYearEnd = Number(fiscYearStart) + 1;
    this.fyText = this.fiscalYearEnd.toString().substring(2,4);
    this.fyNextText = (this.fiscalYearEnd + 1).toString().substring(2, 4);
    return '04-01-' + fiscYearStart;
  }
  displayGetFiscalYear(monthInput: number | string, yearInput: number | string): number {
    const month = Number(monthInput);
    const year = Number(yearInput);
    if (month >= 4) {
      return year + 1;
    } else {
      return year;
    }
  }
  changeDate(e: any) 
  {
    if (this.fifthFormGroup.value.estimatedImplementationMonth != "" 
         && this.fifthFormGroup.value.estimatedImplementationYear != ""
         && this.fifthFormGroup.value.estimatedImplementationMonth != "0"
         && this.fifthFormGroup.value.estimatedImplementationYear != "0"
       ) 
    {
      this.implementationDate = this.fifthFormGroup.value.estimatedImplementationMonth + '-01-' + this.fifthFormGroup.value.estimatedImplementationYear;

      //Adjusting date to Fiscal year
      this.selectedDate = this.getFiscalYear(new Date(this.fifthFormGroup.value.estimatedImplementationYear + '-' + this.fifthFormGroup.value.estimatedImplementationMonth + '-1'));
      this.displayFiscalYear = this.displayGetFiscalYear(this.fifthFormGroup.value.estimatedImplementationMonth,this.fifthFormGroup.value.estimatedImplementationYear);
      this.estimatedMonth = Number(this.fifthFormGroup.value.estimatedImplementationMonth);
      this.estimatedImplementationMonthIndex = this.estimatedMonth < 4 ? this.estimatedMonth + 8 : this.estimatedMonth - 4;

      if (e.target.id == 'month') {
        if (this.CreateKaizen.estimatedImplementationMonth != e.target.value) {
          this.CreateKaizenAcc.estimatedImplementationMonth = e.target.value;
          this.reApprovalReq = true;
        }
        else {
          this.reApprovalReq = false;
        }

        // re-enable any drop downs in the account form
        this.accountArray.controls[0].get('costDirectionID')?.enable();
        this.accountArray.controls[0].get('costTypeID')?.enable();
        this.accountArray.controls[0].get('gLAccountImpactAreaID')?.enable();
        this.accountArray.controls[0].get('detailedAccountId')?.enable();
        this.accountArray.controls[0].get('savingsMeasureID')?.enable();
      }
      else {
        if (this.CreateKaizen.estimatedImplementationYear != e.target.value) {
          this.CreateKaizenAcc.estimatedImplementationYear = e.target.value;
          this.reApprovalReq = true;
        }
        else {
          this.reApprovalReq = false;
        }
        //added this.CreateKaizen.estimatedImplementationYear != '0' to account for when no accounts have be setup
        if (this.editKaizenId != 0 && this.reloadKaizenId == 0 && this.CreateKaizen.estimatedImplementationYear != '0' && this.CreateKaizen.estimatedImplementationYear != '' )
        {
          if (this.accountArray.length > 1) {
            this.destroyAllAccounts();
          }
          else{
            this.delAllAC();
          }
        }
        else {
          this.delAllAC();
        }
      }
    } else {
      // clear the selected date since both drop downs must have values
      this.selectedDate = "";
    }

    this.CreateKaizenAcc.estimatedImplementationDay = '01';
    this.emitAccounts();
  }
  onOperationRateChanged(e: any) {
    this.operationRate = e.target.checked;
    this.operationRateYesNo = this.operationRate ? 'Yes' : 'No';
  }
  onTaktTimeChanged(e: any) {
    this.taktTime = e.target.checked;
    this.taktTimeYesNo = this.taktTime ? 'Yes' : 'No';
  }
  returnNumberOrzero(input: string) {
    if (Number.isNaN(Number(input))) {
      return 0;
    }
    return Number(input);
  }
  changeAccountCurrency() 
  {
    //Check if all the currencies match and if not set the multipleCurrencies flag to hide net total grid
    var accountRawDatArray =  this.fifthFormGroup.getRawValue().accountArray;
    let currentCurrencyId = accountRawDatArray[0].currencyId;
    this.multipleCurrencies= false;
    for (var i = 0; i <= accountRawDatArray.length - 1; i++)
    {
        if(this.multipleCurrencies || currentCurrencyId != accountRawDatArray[i].currencyId)
        {
          this.multipleCurrencies = true;
        }
        currentCurrencyId = accountRawDatArray[i].currencyId;

    }
  }
  getCurrencies(): void {
    this.currencyService.getCurrencies().subscribe(data=> 
      this.currencies = data.data, 
      error => console.log(error), () => this.currenciesLoaded = true); 
  }
  getCurrenciesForEdit(): void {
    firstValueFrom(this.currencyService.getCurrencies()).then((data) => {
      this.currencies = data?.data || [];    
      this.fifthFormGroup.controls['currencyID'].setValue(this.CreateKaizen.currencyID);
    }, (error) => {
      //   console.log("Promise PendingRevision with " + JSON.stringify(error));
    })
  };
  async destroyAllAccounts(): Promise<boolean> {
    await firstValueFrom(this.dialogAccountDeleteService.openDialog().afterClosed()).then(
      (res) => {
        if (res) {
          this.delAllAC();
          this.fundamentalAlert = false;
        }
      });
    return this.fundamentalAlert;
  }
  delAllAC() {
    this.tblNetSavingsShow = false;
    this.reApprovalReq = false;
    this.accountArray = this.fifthFormGroup.get('accountArray') as UntypedFormArray;
    this.tableTotalCost = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]];
    this.accountArray.clear();
    this.addAccount();
    if (this.kaizenAccountArray != null) {
      this.kaizenAccountArray.data = null;
    }
    this.hideFactsTable(0);
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(0) as UntypedFormGroup).get('costDirectionID')?.patchValue(null);
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(0) as UntypedFormGroup).get('costTypeID')?.patchValue(null);
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(0) as UntypedFormGroup).get('gLAccountImpactAreaID')?.patchValue(null);
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(0) as UntypedFormGroup).get('detailedAccountId')?.patchValue(null);
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(0) as UntypedFormGroup).get('savingsMeasureID')?.patchValue(null);
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(0) as UntypedFormGroup).get('costDirectionID')?.enable();
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(0) as UntypedFormGroup).get('costTypeID')?.enable();
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(0) as UntypedFormGroup).get('gLAccountImpactAreaID')?.enable();
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(0) as UntypedFormGroup).get('detailedAccountId')?.enable();
    ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(0) as UntypedFormGroup).get('savingsMeasureID')?.enable();
    this.btnAddAccountShow[0] = true;
  }
  ViewExistingAc() {
    this.showDeletedAc = true;
  }
  ClosexistingAc() {
    this.showDeletedAc = false;
  }
  emitAccounts() {
    this.CreateKaizenAcc.KaizenAccount = this.fifthFormGroup.getRawValue().accountArray;    
 
    this.CreateKaizenAcc.estimatedImplementationDay = '1';
    this.CreateKaizenAcc.estimatedImplementationMonth = this.fifthFormGroup.value.estimatedImplementationMonth;
    this.CreateKaizenAcc.estimatedImplementationYear = this.fifthFormGroup.value.estimatedImplementationYear;

    this.CreateKaizenAcc.fifthFormValid = this.fifthFormValid;
    this.CreateKaizenAcc.reApprovalReq = this.reApprovalReq;
    this.emitKaizenAcounts.emit(this.CreateKaizenAcc);
  }

  setFiscalImpDateMixCPU(accountNumber: number)
  {
    if(this.estimatedImplementationMonthIndex != undefined)
    {
      for(var monthIndex = 0 ; monthIndex < 12; monthIndex++)
        {
          this.fiscalImpDateMixCPU[accountNumber][monthIndex] = this.estimatedImplementationMonthIndex > monthIndex ? 0 : 1
        }
    }
  }
  preventMinusInput(event: KeyboardEvent) {
    if (event.key === '-') {
      event.preventDefault();
    }
  }

  Recalc()
  {
    this.isRecalc = true;
    for (var accountIndex = 0; accountIndex <= this.kaizenAccountArray.data.length - 1; accountIndex++) 
    {     
        let firstMonthIndex: number = 0;
        let nextFiscalYearSavings: number = 0;
        let totalSavings: number = 0;
        let averageCPUSavings: number = 0;
        let totalVolume: number = 0;
        let processCumulative: number = 0;
        this.kaizenMonthlySavingAry = this.kaizenMonthlySavingsList.data.filter(x => x.kaizenAccountId == this.kaizenAccountArray.data[accountIndex].kaizenAccountId);
        //Process Reduction
        if(this.kaizenAccountArray.data[accountIndex].savingsMeasureId == 2)
        {
          firstMonthIndex = this.kaizenMonthlySavingAry.findIndex((v:any)=>v.processReduction>0);
        }
        for (var monthIndex = 0; monthIndex < 12; monthIndex++) 
        {
            //Process Reduction
            if (this.kaizenAccountArray.data[accountIndex].savingsMeasureId == 2)
            {   
              const kms: KaizenMonthlySaving = 
              {
                kaizenMonthlySavingId:this.kaizenMonthlySavingAry[monthIndex].kaizenMonthlySavingId,
                CalendarMonthID: this.yearlyProductFactsAcAry[accountIndex][monthIndex].calendarMonthID,
                WorkingDays: this.yearlyProductFactsAcAry[accountIndex][monthIndex].workingDays,
                WorkingHours: this.yearlyProductFactsAcAry[accountIndex][monthIndex].workingHours,
                NumberOfShifts: this.yearlyProductFactsAcAry[accountIndex][monthIndex].numberOfShifts,
                StandardRate: this.yearlyProductFactsAcAry[accountIndex][monthIndex].standardRate,
                Capacity: this.yearlyProductFactsAcAry[accountIndex][monthIndex].modelVolume,
                MonthHead: this.yearlyProductFactsAcAry[accountIndex][monthIndex].month,
                MonthlySavings: this.yearlyProductFactsAcAry[accountIndex][monthIndex].standardRate * this.yearlyProductFactsAcAry[accountIndex][monthIndex].workingDays * this.yearlyProductFactsAcAry[accountIndex][monthIndex].numberOfShifts * this.kaizenMonthlySavingAry[monthIndex].processReduction * this.yearlyProductFactsAcAry[accountIndex][monthIndex].workingHours,
                costPerUnitSavings: Math.round((this.yearlyProductFactsAcAry[accountIndex][monthIndex].standardRate * this.yearlyProductFactsAcAry[accountIndex][monthIndex].workingDays * this.yearlyProductFactsAcAry[accountIndex][monthIndex].numberOfShifts * this.kaizenMonthlySavingAry[monthIndex].processReduction * this.yearlyProductFactsAcAry[accountIndex][monthIndex].workingHours) / this.yearlyProductFactsAcAry[accountIndex][monthIndex].modelVolume),
                processReduction: this.kaizenMonthlySavingAry[monthIndex].processReduction,
                twtReduction: this.kaizenMonthlySavingAry[monthIndex].twtReduction
              }
              this.kaizenMonthlySaving[monthIndex] = kms;       
              processCumulative += this.accountArray.getRawValue()[accountIndex]['processReductionMon' + monthIndex];
              
              //kms.WorkingHours is string so use the value from the yearlying savings
              totalSavings += Number(kms.StandardRate * kms.WorkingDays * kms.NumberOfShifts *this.yearlyProductFactsAcAry[accountIndex][monthIndex].workingHours * processCumulative);              
              if(monthIndex >= firstMonthIndex)
              {
                totalVolume += this.kaizenMonthlySaving[monthIndex].Capacity;
              }
              
              nextFiscalYearSavings = this.kaizenMonthlySaving[firstMonthIndex].MonthlySavings * (firstMonthIndex)

            }
            //TWT Reduction
            else if (this.kaizenAccountArray.data[accountIndex].savingsMeasureId == 3)
            {
              const kms: KaizenMonthlySaving = 
              {
                kaizenMonthlySavingId:this.kaizenMonthlySavingAry[monthIndex].kaizenMonthlySavingId,
                CalendarMonthID: this.yearlyProductFactsAcAry[accountIndex][monthIndex].calendarMonthID,
                WorkingDays: this.yearlyProductFactsAcAry[accountIndex][monthIndex].workingDays,
                WorkingHours: this.yearlyProductFactsAcAry[accountIndex][monthIndex].workingHours,
                NumberOfShifts: this.yearlyProductFactsAcAry[accountIndex][monthIndex].numberOfShifts,
                StandardRate: this.yearlyProductFactsAcAry[accountIndex][monthIndex].standardRate,
                Capacity: this.yearlyProductFactsAcAry[accountIndex][monthIndex].modelVolume,
                MonthHead: this.yearlyProductFactsAcAry[accountIndex][monthIndex].month,
                MonthlySavings: this.yearlyProductFactsAcAry[accountIndex][monthIndex].standardRate * this.yearlyProductFactsAcAry[accountIndex][monthIndex].workingDays * this.yearlyProductFactsAcAry[accountIndex][monthIndex].numberOfShifts * this.kaizenMonthlySavingAry[monthIndex].twtReduction,
                costPerUnitSavings: Math.round((this.yearlyProductFactsAcAry[accountIndex][monthIndex].standardRate * this.yearlyProductFactsAcAry[accountIndex][monthIndex].workingDays * this.yearlyProductFactsAcAry[accountIndex][monthIndex].numberOfShifts * this.kaizenMonthlySavingAry[monthIndex].twtReduction ) / this.yearlyProductFactsAcAry[accountIndex][monthIndex].modelVolume),
                processReduction: this.kaizenMonthlySavingAry[monthIndex].processReduction,
                twtReduction: this.kaizenMonthlySavingAry[monthIndex].twtReduction
              }
              this.kaizenMonthlySaving[monthIndex] = kms; 
              
              totalSavings += kms.MonthlySavings;
              if(kms.twtReduction > 0)
              {
                totalVolume += this.kaizenMonthlySaving[monthIndex].Capacity;
              }
            }
            //CPU Reduction
            else if(this.kaizenAccountArray.data[accountIndex].savingsMeasureId == 4)
            {
              var implementationMonthIndex = this.monthList.findIndex(x=> x.Value == Number(this.CreateKaizen.estimatedImplementationMonth));

              const kms: KaizenMonthlySaving = {
              kaizenMonthlySavingId: this.kaizenMonthlySavingAry[monthIndex].kaizenMonthlySavingId,
              CalendarMonthID: this.yearlyProductFactsAcAry[accountIndex][monthIndex].calendarMonthID,
              WorkingDays: this.yearlyProductFactsAcAry[accountIndex][monthIndex].workingDays,
              WorkingHours: this.yearlyProductFactsAcAry[accountIndex][monthIndex].workingHours,
              NumberOfShifts: this.yearlyProductFactsAcAry[accountIndex][monthIndex].numberOfShifts,
              StandardRate: this.yearlyProductFactsAcAry[accountIndex][monthIndex].standardRate,
              Capacity: this.yearlyProductFactsAcAry[accountIndex][monthIndex].modelVolume,
              MonthHead: this.yearlyProductFactsAcAry[accountIndex][monthIndex].month,
              MonthlySavings: this.yearlyProductFactsAcAry[accountIndex][monthIndex].modelVolume * this.kaizenMonthlySavingAry[monthIndex].costPerUnitSavings * this.fiscalImpDateMixCPU[accountIndex][monthIndex],
              costPerUnitSavings: this.kaizenAccountArray.data[accountIndex].costPerUnitSavings,
              processReduction: 0,
              twtReduction: 0
              }

              this.kaizenMonthlySaving[monthIndex] = kms;

              if(monthIndex < implementationMonthIndex)
              {
                nextFiscalYearSavings += (Number(this.yearlyProductFactsAcAry[accountIndex][monthIndex].modelVolume) * this.accountArray.getRawValue()[accountIndex].costPerUnit);
              }
              else
              {
                totalSavings +=  this.kaizenMonthlySaving[monthIndex].MonthlySavings;
                totalVolume += this.kaizenMonthlySaving[monthIndex].Capacity;
              }                
            }  
            //Total Cost
            else if(this.kaizenAccountArray.data[accountIndex].savingsMeasureId == 5)                     
            {
              totalSavings += this.kaizenMonthlySaving[monthIndex].MonthlySavings;
            }
        }
        if(this.kaizenAccountArray.data[accountIndex].savingsMeasureId == 2 || this.kaizenAccountArray.data[accountIndex].savingsMeasureId == 3)
        {
           averageCPUSavings = totalSavings/totalVolume;
           ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(accountIndex) as UntypedFormGroup).get('averageCPUSavings')?.patchValue(averageCPUSavings);
        }

        if(this.kaizenAccountArray.data[accountIndex].savingsMeasureId == 5)
        {
          //Get the index of the first month with a non zero cost.  This will be the number of months carry over into next fiscal year
          //Get the last value of the total cost array this is the amount carried over into next year
          //Multiply the number of month times the last total cost to get next fiscal year total saving
          let indexOfFisrtMonthWithCost:number =  this.kaizenMonthlySavingAry.findIndex((v:any)=>v.MonthlySavings>0);
          let lastMonthTotalCost = this.kaizenMonthlySavingAry[11].MonthlySavings;
          nextFiscalYearSavings = indexOfFisrtMonthWithCost*lastMonthTotalCost;
        }

        ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(accountIndex) as UntypedFormGroup).get('totalSavings')?.patchValue(totalSavings);
        ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(accountIndex) as UntypedFormGroup).get('nextFYTotalSavings')?.patchValue(nextFiscalYearSavings);
        ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(accountIndex) as UntypedFormGroup).get('totalVolume')?.patchValue(totalVolume);        
        ((this.fifthFormGroup.get('accountArray') as UntypedFormArray).at(accountIndex) as UntypedFormGroup).get('kaizenMonthlySaving')?.patchValue(this.kaizenMonthlySaving);
    }
    this.isRecalc = false;
    this.emitAccounts();
  }

}